export const CORE_SPELLS = [
    {
        "id":  "acid-splash",
        "name":  {
                     "ru":  "Всплеск кислоты",
                     "en":  "Acid Splash"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/acidSplash",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/acidSplash.html"
                          }
    },
    {
        "id":  "arcane-mark",
        "name":  {
                     "ru":  "Мистическая метка",
                     "en":  "Arcane Mark"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/arcaneMark",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/arcaneMark.html"
                          }
    },
    {
        "id":  "bleed",
        "name":  {
                     "ru":  "Кровотечение",
                     "en":  "Bleed"
                 },
        "classLevels":  {
                            "Cleric":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bleed",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bleed.html"
                          }
    },
    {
        "id":  "create-water",
        "name":  {
                     "ru":  "Создание воды",
                     "en":  "Create Water"
                 },
        "classLevels":  {
                            "Cleric":  0,
                            "Druid":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/createWater",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/createWater.html"
                          }
    },
    {
        "id":  "dancing-lights",
        "name":  {
                     "ru":  "Пляшущие огоньки",
                     "en":  "Dancing Lights"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dancingLights",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dancingLights.html"
                          }
    },
    {
        "id":  "daze",
        "name":  {
                     "ru":  "Ступор",
                     "en":  "Daze"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/daze",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/daze.html"
                          }
    },
    {
        "id":  "detect-magic",
        "name":  {
                     "ru":  "Обнаружение магии",
                     "en":  "Detect Magic"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Cleric":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectMagic",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectMagic.html"
                          }
    },
    {
        "id":  "detect-poison",
        "name":  {
                     "ru":  "Обнаружение ядов",
                     "en":  "Detect Poison"
                 },
        "classLevels":  {
                            "Cleric":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectPoison",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectPoison.html"
                          }
    },
    {
        "id":  "disrupt-undead",
        "name":  {
                     "ru":  "Разрушение нежити",
                     "en":  "Disrupt Undead"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/disruptUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/disruptUndead.html"
                          }
    },
    {
        "id":  "flare",
        "name":  {
                     "ru":  "Вспышка",
                     "en":  "Flare"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/flare",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/flare.html"
                          }
    },
    {
        "id":  "ghost-sound",
        "name":  {
                     "ru":  "Призрачный звук",
                     "en":  "Ghost Sound"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/ghostSound",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/ghostSound.html"
                          }
    },
    {
        "id":  "guidance",
        "name":  {
                     "ru":  "Божественное наставление",
                     "en":  "Guidance"
                 },
        "classLevels":  {
                            "Cleric":  0,
                            "Druid":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/guidance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/guidance.html"
                          }
    },
    {
        "id":  "know-direction",
        "name":  {
                     "ru":  "Определение направления",
                     "en":  "Know Direction"
                 },
        "classLevels":  {
                            "Druid":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/knowDirection",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/knowDirection.html"
                          }
    },
    {
        "id":  "light",
        "name":  {
                     "ru":  "Свет",
                     "en":  "Light"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Cleric":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/light",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/light.html"
                          }
    },
    {
        "id":  "mage-hand",
        "name":  {
                     "ru":  "Магическая рука",
                     "en":  "Mage Hand"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageHand.html"
                          }
    },
    {
        "id":  "mending",
        "name":  {
                     "ru":  "Починка",
                     "en":  "Mending"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Cleric":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mending",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mending.html"
                          }
    },
    {
        "id":  "message",
        "name":  {
                     "ru":  "Сообщение",
                     "en":  "Message"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/message",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/message.html"
                          }
    },
    {
        "id":  "open-close",
        "name":  {
                     "ru":  "Открывание/закрывание",
                     "en":  "Open/Close"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/openClose",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/openClose.html"
                          }
    },
    {
        "id":  "prestidigitation",
        "name":  {
                     "ru":  "Мелкие фокусы",
                     "en":  "Prestidigitation"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/prestidigitation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/prestidigitation.html"
                          }
    },
    {
        "id":  "purify-food-and-drink",
        "name":  {
                     "ru":  "Очищение еды и питья",
                     "en":  "Purify Food and Drink"
                 },
        "classLevels":  {
                            "Cleric":  0,
                            "Druid":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/purifyFoodAndDrink",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/purifyFoodAndDrink.html"
                          }
    },
    {
        "id":  "ray-of-frost",
        "name":  {
                     "ru":  "Ледяной луч",
                     "en":  "Ray of Frost"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/frostRay",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/rayOfFrost.html"
                          }
    },
    {
        "id":  "read-magic",
        "name":  {
                     "ru":  "Чтение магических текстов",
                     "en":  "Read Magic"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Cleric":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/readMagic",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/readMagic.html"
                          }
    },
    {
        "id":  "resistance",
        "name":  {
                     "ru":  "Сопротивляемость",
                     "en":  "Resistance"
                 },
        "classLevels":  {
                            "Bard":  0,
                            "Cleric":  0,
                            "Druid":  0,
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/resistance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/resistance.html"
                          }
    },
    {
        "id":  "stabilize",
        "name":  {
                     "ru":  "Первая помощь",
                     "en":  "Stabilize"
                 },
        "classLevels":  {
                            "Cleric":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stabilize",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stabilize.html"
                          }
    },
    {
        "id":  "touch-of-fatigue",
        "name":  {
                     "ru":  "Утомляющее касание",
                     "en":  "Touch of Fatigue"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/touchOfFatigue",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/touchOfFatigue.html"
                          }
    },
    {
        "id":  "virtue",
        "name":  {
                     "ru":  "Благо",
                     "en":  "Virtue"
                 },
        "classLevels":  {
                            "Cleric":  0
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/virtue",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/virtue.html"
                          }
    },
    {
        "id":  "cat-s-grace-mass",
        "name":  {
                     "ru":  "Кошачья грация",
                     "en":  "Cat\u0027s Grace, Mass"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Druid":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/catGrace",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/catSGrace.html#cat-s-grace-mass"
                          }
    },
    {
        "id":  "contingency",
        "name":  {
                     "ru":  "Заготовка",
                     "en":  "Contingency"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/contingency",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/contingency.html#contingency"
                          }
    },
    {
        "id":  "dimension-door",
        "name":  {
                     "ru":  "Дверь в пространстве",
                     "en":  "Dimension Door"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dimensionDoor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dimensionDoor.html#dimension-door"
                          }
    },
    {
        "id":  "transformation",
        "name":  {
                     "ru":  "Трансформация",
                     "en":  "Transformation"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/transformation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/transformation.html#transformation"
                          }
    },
    {
        "id":  "protection-from-energy",
        "name":  {
                     "ru":  "Защита от стихии",
                     "en":  "Protection from Energy"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3,
                            "Ranger":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/protectionFromEnergy",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/protectionFromEnergy.html#protection-from-energy"
                          }
    },
    {
        "id":  "cure-light-wounds-mass",
        "name":  {
                     "ru":  "Исцеление легких ранений",
                     "en":  "Cure Light Wounds, Mass"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Cleric":  5,
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureLightWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureLightWounds.html#cure-light-wounds-mass"
                          }
    },
    {
        "id":  "divine-power",
        "name":  {
                     "ru":  "Божественная мощь",
                     "en":  "Divine Power"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/divinePower",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/divinePower.html#divine-power"
                          }
    },
    {
        "id":  "dimensional-anchor",
        "name":  {
                     "ru":  "Пространственный якорь",
                     "en":  "Dimensional Anchor"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dimensionalAnchor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dimensionalAnchor.html#dimensional-anchor"
                          }
    },
    {
        "id":  "daylight",
        "name":  {
                     "ru":  "Дневной свет",
                     "en":  "Daylight"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Cleric":  3,
                            "Druid":  3,
                            "Paladin":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/daylight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/daylight.html#daylight"
                          }
    },
    {
        "id":  "summon-nature-s-ally-vii",
        "name":  {
                     "ru":  "Призыв природного союзника VII",
                     "en":  "Summon Nature\u0027s Ally VII"
                 },
        "classLevels":  {
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyVII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-vii"
                          }
    },
    {
        "id":  "protection-from-arrows",
        "name":  {
                     "ru":  "Защита от стрел",
                     "en":  "Protection from Arrows"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/protectionFromArrows",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/protectionFromArrows.html#protection-from-arrows"
                          }
    },
    {
        "id":  "enthrall",
        "name":  {
                     "ru":  "Захватывающая речь",
                     "en":  "Enthrall"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/enthrall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/enthrall.html#enthrall"
                          }
    },
    {
        "id":  "song-of-discord",
        "name":  {
                     "ru":  "Песнь раздора",
                     "en":  "Song of Discord"
                 },
        "classLevels":  {
                            "Bard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/songOfDiscord",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/songOfDiscord.html#song-of-discord"
                          }
    },
    {
        "id":  "speak-with-dead",
        "name":  {
                     "ru":  "Разговор с мертвым",
                     "en":  "Speak with Dead"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/speakWithDead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/speakWithDead.html#speak-with-dead"
                          }
    },
    {
        "id":  "programmed-image",
        "name":  {
                     "ru":  "Программируемый образ",
                     "en":  "Programmed Image"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/programmedImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/programmedImage.html#programmed-image"
                          }
    },
    {
        "id":  "spectral-hand",
        "name":  {
                     "ru":  "Призрачная рука",
                     "en":  "Spectral Hand"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spectralHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spectralHand.html#spectral-hand"
                          }
    },
    {
        "id":  "cat-s-grace",
        "name":  {
                     "ru":  "Кошачья грация",
                     "en":  "Cat\u0027s Grace"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Druid":  2,
                            "Ranger":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/catGrace",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/catSGrace.html#cat-s-grace"
                          }
    },
    {
        "id":  "good-hope",
        "name":  {
                     "ru":  "Надежда",
                     "en":  "Good Hope"
                 },
        "classLevels":  {
                            "Bard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/goodHope",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/goodHope.html#good-hope"
                          }
    },
    {
        "id":  "summon-nature-s-ally-ix",
        "name":  {
                     "ru":  "Призыв природного союзника IX",
                     "en":  "Summon Nature\u0027s Ally IX"
                 },
        "classLevels":  {
                            "Druid":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyIX",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-ix"
                          }
    },
    {
        "id":  "commune-with-nature",
        "name":  {
                     "ru":  "Единение с природой",
                     "en":  "Commune with Nature"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Ranger":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/communeWithNature",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/communeWithNature.html#commune-with-nature"
                          }
    },
    {
        "id":  "animal-messenger",
        "name":  {
                     "ru":  "Зверь-посланник",
                     "en":  "Animal Messenger"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Druid":  2,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animalMessenger",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animalMessenger.html#animal-messenger"
                          }
    },
    {
        "id":  "reduce-animal",
        "name":  {
                     "ru":  "Уменьшение животного",
                     "en":  "Reduce Animal"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/reduceAnimal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/reduceAnimal.html#reduce-animal"
                          }
    },
    {
        "id":  "simulacrum",
        "name":  {
                     "ru":  "Симулякр",
                     "en":  "Simulacrum"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/simulacrum",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/simulacrum.html#simulacrum"
                          }
    },
    {
        "id":  "invisibility-greater",
        "name":  {
                     "ru":  "Невидимость",
                     "en":  "Invisibility, Greater"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/invisibility",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/invisibility.html#invisibility-greater"
                          }
    },
    {
        "id":  "implosion",
        "name":  {
                     "ru":  "Схлопывание",
                     "en":  "Implosion"
                 },
        "classLevels":  {
                            "Cleric":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/implosion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/implosion.html#implosion"
                          }
    },
    {
        "id":  "mage-s-lucubration",
        "name":  {
                     "ru":  "Память волшебника",
                     "en":  "Mage\u0027s Lucubration"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageLucubration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageSLucubration.html#mage-s-lucubration"
                          }
    },
    {
        "id":  "detect-poison",
        "name":  {
                     "ru":  "Обнаружение ядов",
                     "en":  "Detect Poison"
                 },
        "classLevels":  {
                            "Paladin":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectPoison",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectPoison.html#detect-poison"
                          }
    },
    {
        "id":  "delay-poison",
        "name":  {
                     "ru":  "Приостановка действия яда",
                     "en":  "Delay Poison"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Druid":  2,
                            "Paladin":  2,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/delayPoison",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/delayPoison.html#delay-poison"
                          }
    },
    {
        "id":  "statue",
        "name":  {
                     "ru":  "Статуя",
                     "en":  "Statue"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/statue",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/statue.html#statue"
                          }
    },
    {
        "id":  "prismatic-spray",
        "name":  {
                     "ru":  "Радужные брызги",
                     "en":  "Prismatic Spray"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/prismaticSpray",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/prismaticSpray.html#prismatic-spray"
                          }
    },
    {
        "id":  "giant-form-i",
        "name":  {
                     "ru":  "Облик великана I",
                     "en":  "Giant Form I"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/giantFormI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/giantForm.html#giant-form-i"
                          }
    },
    {
        "id":  "maze",
        "name":  {
                     "ru":  "Лабиринт",
                     "en":  "Maze"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/maze",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/maze.html#maze"
                          }
    },
    {
        "id":  "beast-shape-iii",
        "name":  {
                     "ru":  "Облик зверя III",
                     "en":  "Beast Shape III"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/beastShapeIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/beastShape.html#beast-shape-iii"
                          }
    },
    {
        "id":  "bear-s-endurance-mass",
        "name":  {
                     "ru":  "Медвежья стойкость",
                     "en":  "Bear\u0027s Endurance, Mass"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bearEndurance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bearSEndurance.html#bear-s-endurance-mass"
                          }
    },
    {
        "id":  "cure-serious-wounds",
        "name":  {
                     "ru":  "Исцеление тяжелых ранений",
                     "en":  "Cure Serious Wounds"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Cleric":  3,
                            "Druid":  4,
                            "Paladin":  4,
                            "Ranger":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureSeriousWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureSeriousWounds.html#cure-serious-wounds"
                          }
    },
    {
        "id":  "continual-flame",
        "name":  {
                     "ru":  "Вечный свет",
                     "en":  "Continual Flame"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/continualFlame",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/continualFlame.html#continual-flame"
                          }
    },
    {
        "id":  "hold-portal",
        "name":  {
                     "ru":  "Волшебный засов",
                     "en":  "Hold Portal"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holdPortal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holdPortal.html#hold-portal"
                          }
    },
    {
        "id":  "atonement",
        "name":  {
                     "ru":  "Покаяние",
                     "en":  "Atonement"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/atonement",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/atonement.html#atonement"
                          }
    },
    {
        "id":  "regenerate",
        "name":  {
                     "ru":  "Регенерация",
                     "en":  "Regenerate"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Druid":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/regenerate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/regenerate.html#regenerate"
                          }
    },
    {
        "id":  "stone-to-flesh",
        "name":  {
                     "ru":  "Превращение камня в плоть",
                     "en":  "Stone to Flesh"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stoneToFlesh",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stoneToFlesh.html#stone-to-flesh"
                          }
    },
    {
        "id":  "sunbeam",
        "name":  {
                     "ru":  "Солнечный луч",
                     "en":  "Sunbeam"
                 },
        "classLevels":  {
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sunbeam",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sunbeam.html#sunbeam"
                          }
    },
    {
        "id":  "scintillating-pattern",
        "name":  {
                     "ru":  "Блистающий узор",
                     "en":  "Scintillating Pattern"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/scintillatingPattern",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/scintillatingPattern.html#scintillating-pattern"
                          }
    },
    {
        "id":  "poison",
        "name":  {
                     "ru":  "Яд",
                     "en":  "Poison"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Druid":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/poison",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/poison.html#poison"
                          }
    },
    {
        "id":  "repel-vermin",
        "name":  {
                     "ru":  "Барьер для вредителей",
                     "en":  "Repel Vermin"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Cleric":  4,
                            "Druid":  4,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/repelVermin",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/repelVermin.html#repel-vermin"
                          }
    },
    {
        "id":  "globe-of-invulnerability-lesser",
        "name":  {
                     "ru":  "Сфера неуязвимости",
                     "en":  "Globe of Invulnerability, Lesser"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/globeOfInvulnerability",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/globeOfInvulnerability.html#globe-of-invulnerability-lesser"
                          }
    },
    {
        "id":  "dominate-monster",
        "name":  {
                     "ru":  "Подчинение чудовища",
                     "en":  "Dominate Monster"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dominateMonster",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dominateMonster.html#dominate-monster"
                          }
    },
    {
        "id":  "shocking-grasp",
        "name":  {
                     "ru":  "Шоковое прикосновение",
                     "en":  "Shocking Grasp"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shockingGrasp",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shockingGrasp.html#shocking-grasp"
                          }
    },
    {
        "id":  "sleet-storm",
        "name":  {
                     "ru":  "Пурга",
                     "en":  "Sleet Storm"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sleetStorm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sleetStorm.html#sleet-storm"
                          }
    },
    {
        "id":  "eagle-s-splendor",
        "name":  {
                     "ru":  "Орлиное великолепие",
                     "en":  "Eagle\u0027s Splendor"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Paladin":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/eagleSplendor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/eagleSSplendor.html#eagle-s-splendor"
                          }
    },
    {
        "id":  "fear",
        "name":  {
                     "ru":  "Ужас",
                     "en":  "Fear"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fear",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fear.html#fear"
                          }
    },
    {
        "id":  "blasphemy",
        "name":  {
                     "ru":  "Святотатство",
                     "en":  "Blasphemy"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blasphemy",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blasphemy.html#blasphemy"
                          }
    },
    {
        "id":  "scrying",
        "name":  {
                     "ru":  "Тайновидение",
                     "en":  "Scrying"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Cleric":  5,
                            "Druid":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/scrying",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/scrying.html#scrying"
                          }
    },
    {
        "id":  "inflict-serious-wounds",
        "name":  {
                     "ru":  "Нанесение тяжелых ранений",
                     "en":  "Inflict Serious Wounds"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictSeriousWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictSeriousWounds.html#inflict-serious-wounds"
                          }
    },
    {
        "id":  "time-stop",
        "name":  {
                     "ru":  "Остановка времени",
                     "en":  "Time Stop"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/timeStop",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/timeStop.html#time-stop"
                          }
    },
    {
        "id":  "obscuring-mist",
        "name":  {
                     "ru":  "Непроглядный туман",
                     "en":  "Obscuring Mist"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Druid":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/obscuringMist",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/obscuringMist.html#obscuring-mist"
                          }
    },
    {
        "id":  "fabricate",
        "name":  {
                     "ru":  "Изготовление",
                     "en":  "Fabricate"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fabricate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fabricate.html#fabricate"
                          }
    },
    {
        "id":  "arcane-eye",
        "name":  {
                     "ru":  "Мистический глаз",
                     "en":  "Arcane Eye"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/arcaneEye",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/arcaneEye.html#arcane-eye"
                          }
    },
    {
        "id":  "illusory-script",
        "name":  {
                     "ru":  "Иллюзорные письмена",
                     "en":  "Illusory Script"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/illusoryScript",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/illusoryScript.html#illusory-script"
                          }
    },
    {
        "id":  "tiny-hut",
        "name":  {
                     "ru":  "Хижина",
                     "en":  "Tiny Hut"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/tinyHut",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/tinyHut.html#tiny-hut"
                          }
    },
    {
        "id":  "enlarge-person",
        "name":  {
                     "ru":  "Увеличение гуманоида",
                     "en":  "Enlarge Person"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/enlargePerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/enlargePerson.html#enlarge-person"
                          }
    },
    {
        "id":  "magic-circle-against-chaos-evil-good-law",
        "name":  {
                     "ru":  "Магический круг против хаоса",
                     "en":  "Magic Circle against Chaos/Evil/Good/Law"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicCircleAgainstChaos",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicCircleAgainstChaos.html#magic-circle-against-chaos"
                          }
    },
    {
        "id":  "black-tentacles",
        "name":  {
                     "ru":  "Черные щупальца",
                     "en":  "Black Tentacles"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blackTentacles",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blackTentacles.html#black-tentacles"
                          }
    },
    {
        "id":  "ghoul-touch",
        "name":  {
                     "ru":  "Касание упыря",
                     "en":  "Ghoul Touch"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/ghoulTouch",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/ghoulTouch.html#ghoul-touch"
                          }
    },
    {
        "id":  "reduce-person-mass",
        "name":  {
                     "ru":  "Уменьшение гуманоида",
                     "en":  "Reduce Person, Mass"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/reducePerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/reducePerson.html#reduce-person-mass"
                          }
    },
    {
        "id":  "hold-animal",
        "name":  {
                     "ru":  "Паралич (животное)",
                     "en":  "Hold Animal"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holdAnimal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holdAnimal.html#hold-animal"
                          }
    },
    {
        "id":  "globe-of-invulnerability",
        "name":  {
                     "ru":  "Сфера неуязвимости",
                     "en":  "Globe of Invulnerability"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/globeOfInvulnerability",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/globeOfInvulnerability.html#globe-of-invulnerability"
                          }
    },
    {
        "id":  "create-undead",
        "name":  {
                     "ru":  "Создание нежити",
                     "en":  "Create Undead"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/createUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/createUndead.html#create-undead"
                          }
    },
    {
        "id":  "meld-into-stone",
        "name":  {
                     "ru":  "Слияние с камнем",
                     "en":  "Meld into Stone"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/meldIntoStone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/meldIntoStone.html#meld-into-stone"
                          }
    },
    {
        "id":  "flesh-to-stone",
        "name":  {
                     "ru":  "Превращение плоти в камень",
                     "en":  "Flesh to Stone"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fleshToStone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fleshToStone.html#flesh-to-stone"
                          }
    },
    {
        "id":  "flame-strike",
        "name":  {
                     "ru":  "Огненный столп",
                     "en":  "Flame Strike"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/flameStrike",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/flameStrike.html#flame-strike"
                          }
    },
    {
        "id":  "plant-shape-iii",
        "name":  {
                     "ru":  "Облик растения III",
                     "en":  "Plant Shape III"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/plantShapeIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/plantShape.html#plant-shape-iii"
                          }
    },
    {
        "id":  "invisibility-mass",
        "name":  {
                     "ru":  "Невидимость",
                     "en":  "Invisibility, Mass"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/invisibility",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/invisibility.html#invisibility-mass"
                          }
    },
    {
        "id":  "shadow-conjuration",
        "name":  {
                     "ru":  "Теневое воплощение",
                     "en":  "Shadow Conjuration"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shadowConjuration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shadowConjuration.html#shadow-conjuration"
                          }
    },
    {
        "id":  "invisibility",
        "name":  {
                     "ru":  "Невидимость",
                     "en":  "Invisibility"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/invisibility",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/invisibility.html#invisibility"
                          }
    },
    {
        "id":  "clone",
        "name":  {
                     "ru":  "Клон",
                     "en":  "Clone"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/clone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/clone.html#clone"
                          }
    },
    {
        "id":  "false-life",
        "name":  {
                     "ru":  "Ложная жизнь",
                     "en":  "False Life"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/falseLife",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/falseLife.html#false-life"
                          }
    },
    {
        "id":  "project-image",
        "name":  {
                     "ru":  "Собственный образ",
                     "en":  "Project Image"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/projectImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/projectImage.html#project-image"
                          }
    },
    {
        "id":  "mnemonic-enhancer",
        "name":  {
                     "ru":  "Улучшение памяти",
                     "en":  "Mnemonic Enhancer"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mnemonicEnhancer",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mnemonicEnhancer.html#mnemonic-enhancer"
                          }
    },
    {
        "id":  "expeditious-retreat",
        "name":  {
                     "ru":  "Поспешное отступление",
                     "en":  "Expeditious Retreat"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/expeditiousRetreat",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/expeditiousRetreat.html#expeditious-retreat"
                          }
    },
    {
        "id":  "blight",
        "name":  {
                     "ru":  "Увядание",
                     "en":  "Blight"
                 },
        "classLevels":  {
                            "Druid":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blight.html#blight"
                          }
    },
    {
        "id":  "transmute-mud-to-rock",
        "name":  {
                     "ru":  "Превращение грязи в камень",
                     "en":  "Transmute Mud to Rock"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/transmuteMudToRock",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/transmuteMudToRock.html#transmute-mud-to-rock"
                          }
    },
    {
        "id":  "cause-fear",
        "name":  {
                     "ru":  "Устрашение",
                     "en":  "Cause Fear"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/causeFear",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/causeFear.html#cause-fear"
                          }
    },
    {
        "id":  "align-weapon",
        "name":  {
                     "ru":  "Настройка оружия",
                     "en":  "Align Weapon"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/alignWeapon",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/alignWeapon.html#align-weapon"
                          }
    },
    {
        "id":  "charm-animal",
        "name":  {
                     "ru":  "Приворот (животное)",
                     "en":  "Charm Animal"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/charmAnimal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/charmAnimal.html#charm-animal"
                          }
    },
    {
        "id":  "enervation",
        "name":  {
                     "ru":  "Истощение",
                     "en":  "Enervation"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/enervation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/enervation.html#enervation"
                          }
    },
    {
        "id":  "polymorph",
        "name":  {
                     "ru":  "Полиморф",
                     "en":  "Polymorph"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/polymorph",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/polymorph.html#polymorph"
                          }
    },
    {
        "id":  "calm-emotions",
        "name":  {
                     "ru":  "Спокойствие",
                     "en":  "Calm Emotions"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/calmEmotions",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/calmEmotions.html#calm-emotions"
                          }
    },
    {
        "id":  "giant-form-ii",
        "name":  {
                     "ru":  "Облик великана II",
                     "en":  "Giant Form II"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/giantFormII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/giantForm.html#giant-form-ii"
                          }
    },
    {
        "id":  "polar-ray",
        "name":  {
                     "ru":  "Морозный луч",
                     "en":  "Polar Ray"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/polarRay",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/polarRay.html#polar-ray"
                          }
    },
    {
        "id":  "restoration-lesser",
        "name":  {
                     "ru":  "Восстановление",
                     "en":  "Restoration, Lesser"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Druid":  2,
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/restoration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/restoration.html#restoration-lesser"
                          }
    },
    {
        "id":  "prismatic-sphere",
        "name":  {
                     "ru":  "Радужная сфера",
                     "en":  "Prismatic Sphere"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/prismaticSphere",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/prismaticSphere.html#prismatic-sphere"
                          }
    },
    {
        "id":  "bestow-curse",
        "name":  {
                     "ru":  "Проклятие",
                     "en":  "Bestow Curse"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bestowCurse",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bestowCurse.html#bestow-curse"
                          }
    },
    {
        "id":  "permanent-image",
        "name":  {
                     "ru":  "Вечный образ",
                     "en":  "Permanent Image"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/permanentImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/permanentImage.html#permanent-image"
                          }
    },
    {
        "id":  "guards-and-wards",
        "name":  {
                     "ru":  "Охранные чары",
                     "en":  "Guards and Wards"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/guardsAndWards",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/guardsAndWards.html#guards-and-wards"
                          }
    },
    {
        "id":  "searing-light",
        "name":  {
                     "ru":  "Палящий свет",
                     "en":  "Searing Light"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/searingLight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/searingLight.html#searing-light"
                          }
    },
    {
        "id":  "phantasmal-killer",
        "name":  {
                     "ru":  "Убийственный фантазм",
                     "en":  "Phantasmal Killer"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/phantasmalKiller",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/phantasmalKiller.html#phantasmal-killer"
                          }
    },
    {
        "id":  "passwall",
        "name":  {
                     "ru":  "Проход сквозь стену",
                     "en":  "Passwall"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/passwall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/passwall.html#passwall"
                          }
    },
    {
        "id":  "hypnotism",
        "name":  {
                     "ru":  "Гипноз",
                     "en":  "Hypnotism"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hypnotism",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hypnotism.html#hypnotism"
                          }
    },
    {
        "id":  "mind-fog",
        "name":  {
                     "ru":  "Туман безволия",
                     "en":  "Mind Fog"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mindFog",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mindFog.html#mind-fog"
                          }
    },
    {
        "id":  "invisibility-purge",
        "name":  {
                     "ru":  "Сфера прозрения",
                     "en":  "Invisibility Purge"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/invisibilityPurge",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/invisibilityPurge.html#invisibility-purge"
                          }
    },
    {
        "id":  "virtue",
        "name":  {
                     "ru":  "Благо",
                     "en":  "Virtue"
                 },
        "classLevels":  {
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/virtue",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/virtue.html#virtue"
                          }
    },
    {
        "id":  "transmute-rock-to-mud",
        "name":  {
                     "ru":  "Превращение камня в грязь",
                     "en":  "Transmute Rock to Mud"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/transmuteRockToMud",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/transmuteRockToMud.html#transmute-rock-to-mud"
                          }
    },
    {
        "id":  "transport-via-plants",
        "name":  {
                     "ru":  "Путешествие сквозь растения",
                     "en":  "Transport via Plants"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/transportViaPlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/transportViaPlants.html#transport-via-plants"
                          }
    },
    {
        "id":  "locate-object",
        "name":  {
                     "ru":  "Поиск предмета",
                     "en":  "Locate Object"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  3,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/locateObject",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/locateObject.html#locate-object"
                          }
    },
    {
        "id":  "earthquake",
        "name":  {
                     "ru":  "Землетрясение",
                     "en":  "Earthquake"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/earthquake",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/earthquake.html#earthquake"
                          }
    },
    {
        "id":  "hallow",
        "name":  {
                     "ru":  "Посвящение добру",
                     "en":  "Hallow"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hallow",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hallow.html#hallow"
                          }
    },
    {
        "id":  "storm-of-vengeance",
        "name":  {
                     "ru":  "Буря возмездия",
                     "en":  "Storm of Vengeance"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Druid":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stormOfVengeance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stormOfVengeance.html#storm-of-vengeance"
                          }
    },
    {
        "id":  "mage-s-disjunction",
        "name":  {
                     "ru":  "Магическое разъединение",
                     "en":  "Mage\u0027s Disjunction"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageDisjunction",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageSDisjunction.html#mage-s-disjunction"
                          }
    },
    {
        "id":  "screen",
        "name":  {
                     "ru":  "Завеса",
                     "en":  "Screen"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/screen",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/screen.html#screen"
                          }
    },
    {
        "id":  "fog-cloud",
        "name":  {
                     "ru":  "Облако тумана",
                     "en":  "Fog Cloud"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fogCloud",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fogCloud.html"
                          }
    },
    {
        "id":  "giant-vermin",
        "name":  {
                     "ru":  "Гигантские насекомые",
                     "en":  "Giant Vermin"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/giantVermin",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/giantVermin.html#giant-vermin"
                          }
    },
    {
        "id":  "legend-lore",
        "name":  {
                     "ru":  "Знание легенд",
                     "en":  "Legend Lore"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/legendLore",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/legendLore.html#legend-lore"
                          }
    },
    {
        "id":  "heal",
        "name":  {
                     "ru":  "Излечение",
                     "en":  "Heal"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/heal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/heal.html#heal"
                          }
    },
    {
        "id":  "blur",
        "name":  {
                     "ru":  "Расплывчатость",
                     "en":  "Blur"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blur",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blur.html#blur"
                          }
    },
    {
        "id":  "bull-s-strength-mass",
        "name":  {
                     "ru":  "Бычья сила",
                     "en":  "Bull\u0027s Strength, Mass"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bullStrength",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bullSStrength.html#bull-s-strength-mass"
                          }
    },
    {
        "id":  "prying-eyes",
        "name":  {
                     "ru":  "Глаза-разведчики",
                     "en":  "Prying Eyes"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/pryingEyes",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/pryingEyes.html#prying-eyes"
                          }
    },
    {
        "id":  "create-food-and-water",
        "name":  {
                     "ru":  "Создание еды и питья",
                     "en":  "Create Food and Water"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/createFoodAndWater",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/createFoodAndWater.html#create-food-and-water"
                          }
    },
    {
        "id":  "create-water",
        "name":  {
                     "ru":  "Создание воды",
                     "en":  "Create Water"
                 },
        "classLevels":  {
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/createWater",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/createWater.html#create-water"
                          }
    },
    {
        "id":  "deeper-darkness",
        "name":  {
                     "ru":  "Кромешная тьма",
                     "en":  "Deeper Darkness"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/deeperDarkness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/deeperDarkness.html#deeper-darkness"
                          }
    },
    {
        "id":  "symbol-of-pain",
        "name":  {
                     "ru":  "Символ боли",
                     "en":  "Symbol of Pain"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfPain",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfPain.html#symbol-of-pain"
                          }
    },
    {
        "id":  "wall-of-fire",
        "name":  {
                     "ru":  "Огненная стена",
                     "en":  "Wall of Fire"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fireWall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wallOfFire.html#wall-of-fire"
                          }
    },
    {
        "id":  "protection-from-spells",
        "name":  {
                     "ru":  "Защита от чар",
                     "en":  "Protection from Spells"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/protectionFromSpells",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/protectionFromSpells.html#protection-from-spells"
                          }
    },
    {
        "id":  "floating-disk",
        "name":  {
                     "ru":  "Парящий диск",
                     "en":  "Floating Disk"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/floatingDisk",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/floatingDisk.html#floating-disk"
                          }
    },
    {
        "id":  "disrupting-weapon",
        "name":  {
                     "ru":  "Разрушительное оружие",
                     "en":  "Disrupting Weapon"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/disruptingWeapon",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/disruptingWeapon.html#disrupting-weapon"
                          }
    },
    {
        "id":  "planar-binding",
        "name":  {
                     "ru":  "Потусторонний слуга",
                     "en":  "Planar Binding"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planarBinding",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planarBinding.html#planar-binding"
                          }
    },
    {
        "id":  "lightning-bolt",
        "name":  {
                     "ru":  "Удар молнии",
                     "en":  "Lightning Bolt"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/lightningBolt",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/lightningBolt.html#lightning-bolt"
                          }
    },
    {
        "id":  "waves-of-exhaustion",
        "name":  {
                     "ru":  "Волна бессилия",
                     "en":  "Waves of Exhaustion"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/exhaustionWaves",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wavesOfExhaustion.html#waves-of-exhaustion"
                          }
    },
    {
        "id":  "inflict-light-wounds",
        "name":  {
                     "ru":  "Нанесение легких ранений",
                     "en":  "Inflict Light Wounds"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictLightWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictLightWounds.html#inflict-light-wounds"
                          }
    },
    {
        "id":  "cure-serious-wounds-mass",
        "name":  {
                     "ru":  "Исцеление тяжелых ранений",
                     "en":  "Cure Serious Wounds, Mass"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureSeriousWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureSeriousWounds.html#cure-serious-wounds-mass"
                          }
    },
    {
        "id":  "magic-weapon",
        "name":  {
                     "ru":  "Волшебное оружие",
                     "en":  "Magic Weapon"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Paladin":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicWeapon",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicWeapon.html#magic-weapon"
                          }
    },
    {
        "id":  "detect-undead",
        "name":  {
                     "ru":  "Обнаружение нежити",
                     "en":  "Detect Undead"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Paladin":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectUndead.html#detect-undead"
                          }
    },
    {
        "id":  "animate-dead",
        "name":  {
                     "ru":  "Оживить мертвецов",
                     "en":  "Animate Dead"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animateDead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animateDead.html#animate-dead"
                          }
    },
    {
        "id":  "eagle-s-splendor-mass",
        "name":  {
                     "ru":  "Орлиное великолепие",
                     "en":  "Eagle\u0027s Splendor, Mass"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/eagleSplendor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/eagleSSplendor.html#eagle-s-splendor-mass"
                          }
    },
    {
        "id":  "enlarge-person-mass",
        "name":  {
                     "ru":  "Увеличение гуманоида",
                     "en":  "Enlarge Person, Mass"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/enlargePerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/enlargePerson.html#enlarge-person-mass"
                          }
    },
    {
        "id":  "animal-trance",
        "name":  {
                     "ru":  "Звериный транс",
                     "en":  "Animal Trance"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animalTrance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animalTrance.html#animal-trance"
                          }
    },
    {
        "id":  "irresistible-dance",
        "name":  {
                     "ru":  "Безудержная пляска",
                     "en":  "Irresistible Dance"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/irresistibleDance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/irresistibleDance.html#irresistible-dance"
                          }
    },
    {
        "id":  "power-word-blind",
        "name":  {
                     "ru":  "Слово силы: слепота",
                     "en":  "Power Word Blind"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/powerWordBlind",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/powerWordBlind.html#power-word-blind"
                          }
    },
    {
        "id":  "unhallow",
        "name":  {
                     "ru":  "Посвящение злу",
                     "en":  "Unhallow"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/unhallow",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/unhallow.html#unhallow"
                          }
    },
    {
        "id":  "dominate-person",
        "name":  {
                     "ru":  "Подчинение гуманоида",
                     "en":  "Dominate Person"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dominatePerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dominatePerson.html#dominate-person"
                          }
    },
    {
        "id":  "contagion",
        "name":  {
                     "ru":  "Болезнь",
                     "en":  "Contagion"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/contagion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/contagion.html#contagion"
                          }
    },
    {
        "id":  "flame-arrow",
        "name":  {
                     "ru":  "Огненные стрелы",
                     "en":  "Flame Arrow"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/flameArrow",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/flameArrow.html#flame-arrow"
                          }
    },
    {
        "id":  "beast-shape-ii",
        "name":  {
                     "ru":  "Облик зверя II",
                     "en":  "Beast Shape II"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/beastShapeII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/beastShape.html#beast-shape-ii"
                          }
    },
    {
        "id":  "scorching-ray",
        "name":  {
                     "ru":  "Опаляющий луч",
                     "en":  "Scorching Ray"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/scorchingRay",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/scorchingRay.html#scorching-ray"
                          }
    },
    {
        "id":  "halt-undead",
        "name":  {
                     "ru":  "Удержание нежити",
                     "en":  "Halt Undead"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/haltUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/haltUndead.html#halt-undead-copy"
                          }
    },
    {
        "id":  "freedom-of-movement",
        "name":  {
                     "ru":  "Свобода движений",
                     "en":  "Freedom of Movement"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Cleric":  4,
                            "Druid":  4,
                            "Ranger":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/freedomOfMovement",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/freedomOfMovement.html#freedom-of-movement"
                          }
    },
    {
        "id":  "see-invisibility",
        "name":  {
                     "ru":  "Увидеть невидимое",
                     "en":  "See Invisibility"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/seeInvisibility",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/seeInvisibility.html#see-invisibility"
                          }
    },
    {
        "id":  "beast-shape-iv",
        "name":  {
                     "ru":  "Облик зверя IV",
                     "en":  "Beast Shape IV"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/beastShapeIV",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/beastShape.html#beast-shape-iv"
                          }
    },
    {
        "id":  "binding",
        "name":  {
                     "ru":  "Сковывание",
                     "en":  "Binding"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/binding",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/binding.html#binding"
                          }
    },
    {
        "id":  "freedom",
        "name":  {
                     "ru":  "Свобода",
                     "en":  "Freedom"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/freedom",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/freedom.html#freedom"
                          }
    },
    {
        "id":  "remove-paralysis",
        "name":  {
                     "ru":  "Снятие паралича",
                     "en":  "Remove Paralysis"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Paladin":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/removeParalysis",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/removeParalysis.html#remove-paralysis"
                          }
    },
    {
        "id":  "snare",
        "name":  {
                     "ru":  "Силки",
                     "en":  "Snare"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/snare",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/snare.html#snare"
                          }
    },
    {
        "id":  "cure-light-wounds",
        "name":  {
                     "ru":  "Исцеление легких ранений",
                     "en":  "Cure Light Wounds"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  1,
                            "Druid":  1,
                            "Paladin":  1,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureLightWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureLightWounds.html#cure-light-wounds"
                          }
    },
    {
        "id":  "mind-blank",
        "name":  {
                     "ru":  "Сокрытие разума",
                     "en":  "Mind Blank"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mindBlank",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mindBlank.html#mind-blank"
                          }
    },
    {
        "id":  "magic-aura",
        "name":  {
                     "ru":  "Аура магии",
                     "en":  "Magic Aura"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicAura",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicAura.html#magic-aura"
                          }
    },
    {
        "id":  "darkness",
        "name":  {
                     "ru":  "Тьма",
                     "en":  "Darkness"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/darkness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/darkness.html#darkness"
                          }
    },
    {
        "id":  "forceful-hand",
        "name":  {
                     "ru":  "Могучая рука",
                     "en":  "Forceful Hand"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/forcefulHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/forcefulHand.html#forceful-hand"
                          }
    },
    {
        "id":  "stinking-cloud",
        "name":  {
                     "ru":  "Смрадное облако",
                     "en":  "Stinking Cloud"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stinkingCloud",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stinkingCloud.html#stinking-cloud"
                          }
    },
    {
        "id":  "true-seeing",
        "name":  {
                     "ru":  "Истинное зрение",
                     "en":  "True Seeing"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  7,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/trueSeeing",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/trueSeeing.html#true-seeing"
                          }
    },
    {
        "id":  "clairaudience-clairvoyance",
        "name":  {
                     "ru":  "Ясновидение/яснослышание",
                     "en":  "Clairaudience/Clairvoyance"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/clairaudienceClairvoyance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/clairaudienceClairvoyance.html#clairaudience-clairvoyance"
                          }
    },
    {
        "id":  "speak-with-animals",
        "name":  {
                     "ru":  "Разговор с животными",
                     "en":  "Speak with Animals"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/speakWithAnimals",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/speakWithAnimals.html#speak-with-animals"
                          }
    },
    {
        "id":  "form-of-the-dragon-iii",
        "name":  {
                     "ru":  "Облик дракона III",
                     "en":  "Form of the Dragon III"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dragonFormIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/formOfTheDragon.html#form-of-the-dragon-iii"
                          }
    },
    {
        "id":  "augury",
        "name":  {
                     "ru":  "Предвидение",
                     "en":  "Augury"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/augury",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/augury.html#augury"
                          }
    },
    {
        "id":  "magic-weapon-greater",
        "name":  {
                     "ru":  "Волшебное оружие",
                     "en":  "Magic Weapon, Greater"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Paladin":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicWeapon",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicWeapon.html#magic-weapon-greater"
                          }
    },
    {
        "id":  "fire-shield",
        "name":  {
                     "ru":  "Огненный щит",
                     "en":  "Fire Shield"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fireShield",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fireShield.html#fire-shield"
                          }
    },
    {
        "id":  "word-of-recall",
        "name":  {
                     "ru":  "Слово возвращения",
                     "en":  "Word of Recall"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wordOfRecall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wordOfRecall.html#word-of-recall"
                          }
    },
    {
        "id":  "burning-hands",
        "name":  {
                     "ru":  "Пылающие руки",
                     "en":  "Burning Hands"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/burningHands",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/burningHands.html#burning-hands"
                          }
    },
    {
        "id":  "air-walk",
        "name":  {
                     "ru":  "Хождение по воздуху",
                     "en":  "Air Walk"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/airWalk",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/airWalk.html#air-walk"
                          }
    },
    {
        "id":  "keen-edge",
        "name":  {
                     "ru":  "Острое лезвие",
                     "en":  "Keen Edge"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/keenEdge",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/keenEdge.html#keen-edge"
                          }
    },
    {
        "id":  "spell-immunity",
        "name":  {
                     "ru":  "Невосприимчивость к заклинаниям",
                     "en":  "Spell Immunity"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spellImmunity",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spellImmunity.html#spell-immunity"
                          }
    },
    {
        "id":  "sculpt-sound",
        "name":  {
                     "ru":  "Изменение звуков",
                     "en":  "Sculpt Sound"
                 },
        "classLevels":  {
                            "Bard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sculptSound",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sculptSound.html#sculpt-sound"
                          }
    },
    {
        "id":  "pyrotechnics",
        "name":  {
                     "ru":  "Пиротехника",
                     "en":  "Pyrotechnics"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/pyrotechnics",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/pyrotechnics.html#pyrotechnics"
                          }
    },
    {
        "id":  "heroes-feast",
        "name":  {
                     "ru":  "Пир героев",
                     "en":  "Heroes\u0027 Feast"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/heroesFeast",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/heroesFeast.html#heroes-feast"
                          }
    },
    {
        "id":  "energy-drain",
        "name":  {
                     "ru":  "Вытягивание жизни",
                     "en":  "Energy Drain"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/energyDrain",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/energyDrain.html#energy-drain"
                          }
    },
    {
        "id":  "cure-critical-wounds",
        "name":  {
                     "ru":  "Исцеление критических ранений",
                     "en":  "Cure Critical Wounds"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Cleric":  4,
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureCriticalWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureCriticalWounds.html#cure-critical-wounds"
                          }
    },
    {
        "id":  "feeblemind",
        "name":  {
                     "ru":  "Слабоумие",
                     "en":  "Feeblemind"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/feeblemind",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/feeblemind.html#feeblemind"
                          }
    },
    {
        "id":  "harm",
        "name":  {
                     "ru":  "Повреждение",
                     "en":  "Harm"
                 },
        "classLevels":  {
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/harm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/harm.html#harm"
                          }
    },
    {
        "id":  "resilient-sphere",
        "name":  {
                     "ru":  "Силовая сфера",
                     "en":  "Resilient Sphere"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/resilientSphere",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/resilientSphere.html#resilient-sphere"
                          }
    },
    {
        "id":  "magic-fang-greater",
        "name":  {
                     "ru":  "Волшебный клык",
                     "en":  "Magic Fang, Greater"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicFang",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicFang.html#magic-fang-greater"
                          }
    },
    {
        "id":  "chill-metal",
        "name":  {
                     "ru":  "Ледяной металл",
                     "en":  "Chill Metal"
                 },
        "classLevels":  {
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/chillMetal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/chillMetal.html#chill-metal"
                          }
    },
    {
        "id":  "knock",
        "name":  {
                     "ru":  "Стук",
                     "en":  "Knock"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/knock",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/knock.html#knock"
                          }
    },
    {
        "id":  "summon-nature-s-ally-viii",
        "name":  {
                     "ru":  "Призыв природного союзника VIII",
                     "en":  "Summon Nature\u0027s Ally VIII"
                 },
        "classLevels":  {
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyVIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-viii"
                          }
    },
    {
        "id":  "remove-fear",
        "name":  {
                     "ru":  "Умиротворение",
                     "en":  "Remove Fear"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/removeFear",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/removeFear.html#remove-fear"
                          }
    },
    {
        "id":  "antilife-shell",
        "name":  {
                     "ru":  "Барьер для жизни",
                     "en":  "Antilife Shell"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/antilifeShell",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/antilifeShell.html#antilife-shell"
                          }
    },
    {
        "id":  "inflict-critical-wounds-mass",
        "name":  {
                     "ru":  "Нанесение критических ранений",
                     "en":  "Inflict Critical Wounds, Mass"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictCriticalWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictCriticalWounds.html#inflict-critical-wounds-mass"
                          }
    },
    {
        "id":  "hold-monster-mass",
        "name":  {
                     "ru":  "Паралич (чудовище)",
                     "en":  "Hold Monster, Mass"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holdMonster",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holdMonster.html#hold-monster-mass"
                          }
    },
    {
        "id":  "confusion-lesser",
        "name":  {
                     "ru":  "Замешательство",
                     "en":  "Confusion, Lesser"
                 },
        "classLevels":  {
                            "Bard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/confusion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/confusion.html#confusion-lesser"
                          }
    },
    {
        "id":  "aid",
        "name":  {
                     "ru":  "Помощь",
                     "en":  "Aid"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/aid",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/aid.html#aid"
                          }
    },
    {
        "id":  "symbol-of-stunning",
        "name":  {
                     "ru":  "Символ шока",
                     "en":  "Symbol of Stunning"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfStunning",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfStunning.html#symbol-of-stunning"
                          }
    },
    {
        "id":  "animate-plants",
        "name":  {
                     "ru":  "Оживить растения",
                     "en":  "Animate Plants"
                 },
        "classLevels":  {
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animatePlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animatePlants.html#animate-plants"
                          }
    },
    {
        "id":  "persistent-image",
        "name":  {
                     "ru":  "Устойчивый образ",
                     "en":  "Persistent Image"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/persistentImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/persistentImage.html#persistent-image"
                          }
    },
    {
        "id":  "ironwood",
        "name":  {
                     "ru":  "Железное дерево",
                     "en":  "Ironwood"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/ironwood",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/ironwood.html#ironwood"
                          }
    },
    {
        "id":  "dismissal",
        "name":  {
                     "ru":  "Возвращение",
                     "en":  "Dismissal"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dismissal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dismissal.html#dismissal"
                          }
    },
    {
        "id":  "dispel-chaos-evil-good-law",
        "name":  {
                     "ru":  "Рассеивание зла",
                     "en":  "Dispel Chaos/Evil/Good/Law"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dispelEvil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dispelEvil.html#dispel-evil"
                          }
    },
    {
        "id":  "insect-plague",
        "name":  {
                     "ru":  "Призыв ос",
                     "en":  "Insect Plague"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/insectPlague",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/insectPlague.html#insect-plague"
                          }
    },
    {
        "id":  "summon-nature-s-ally-vi",
        "name":  {
                     "ru":  "Призыв природного союзника VI",
                     "en":  "Summon Nature\u0027s Ally VI"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyVI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-vi"
                          }
    },
    {
        "id":  "grease",
        "name":  {
                     "ru":  "Масло",
                     "en":  "Grease"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/grease",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/grease.html#grease"
                          }
    },
    {
        "id":  "detect-thoughts",
        "name":  {
                     "ru":  "Чтение мыслей",
                     "en":  "Detect Thoughts"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectThoughts",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectThoughts.html#detect-thoughts"
                          }
    },
    {
        "id":  "water-walk",
        "name":  {
                     "ru":  "Хождение по воде",
                     "en":  "Water Walk"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/waterWalk",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/waterWalk.html#water-walk"
                          }
    },
    {
        "id":  "displacement",
        "name":  {
                     "ru":  "Марево",
                     "en":  "Displacement"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/displacement",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/displacement.html#displacement"
                          }
    },
    {
        "id":  "restoration",
        "name":  {
                     "ru":  "Восстановление",
                     "en":  "Restoration"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Paladin":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/restoration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/restoration.html#restoration"
                          }
    },
    {
        "id":  "sequester",
        "name":  {
                     "ru":  "Изоляция",
                     "en":  "Sequester"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sequester",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sequester.html#sequester"
                          }
    },
    {
        "id":  "daze-monster",
        "name":  {
                     "ru":  "Ступор (чудовище)",
                     "en":  "Daze Monster"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dazeMonster",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dazeMonster.html#daze-monster"
                          }
    },
    {
        "id":  "telekinesis",
        "name":  {
                     "ru":  "Телекинез",
                     "en":  "Telekinesis"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/telekinesis",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/telekinesis.html#telekinesis"
                          }
    },
    {
        "id":  "unholy-aura",
        "name":  {
                     "ru":  "Нечестивая аура",
                     "en":  "Unholy Aura"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/unholyAura",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/unholyAura.html#unholy-aura"
                          }
    },
    {
        "id":  "detect-chaos-evil-good-law",
        "name":  {
                     "ru":  "Определение мировоззрения (хаос)",
                     "en":  "Detect Chaos/Evil/Good/Law"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectChaos",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectChaos.html#detect-chaos"
                          }
    },
    {
        "id":  "spiritual-weapon",
        "name":  {
                     "ru":  "Призрачное оружие",
                     "en":  "Spiritual Weapon"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spiritualWeapon",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spiritualWeapon.html#spiritual-weapon"
                          }
    },
    {
        "id":  "shades",
        "name":  {
                     "ru":  "Живые тени",
                     "en":  "Shades"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shades",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shades.html#shades"
                          }
    },
    {
        "id":  "sleep",
        "name":  {
                     "ru":  "Сон",
                     "en":  "Sleep"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sleep",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sleep.html#sleep"
                          }
    },
    {
        "id":  "shatter",
        "name":  {
                     "ru":  "Разбивающий звук",
                     "en":  "Shatter"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shatter",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shatter.html#shatter"
                          }
    },
    {
        "id":  "minor-image",
        "name":  {
                     "ru":  "Малый образ",
                     "en":  "Minor Image"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/minorImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/minorImage.html#minor-image"
                          }
    },
    {
        "id":  "astral-projection",
        "name":  {
                     "ru":  "Астральная проекция",
                     "en":  "Astral Projection"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/astralProjection",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/astralProjection.html#astral-projection"
                          }
    },
    {
        "id":  "interposing-hand",
        "name":  {
                     "ru":  "Преграждающая рука",
                     "en":  "Interposing Hand"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/interposingHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/interposingHand.html#interposing-hand"
                          }
    },
    {
        "id":  "silent-image",
        "name":  {
                     "ru":  "Немой образ",
                     "en":  "Silent Image"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/silentImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/silentImage.html#silent-image"
                          }
    },
    {
        "id":  "summon-nature-s-ally-ii",
        "name":  {
                     "ru":  "Призыв природного союзника II",
                     "en":  "Summon Nature\u0027s Ally II"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-ii"
                          }
    },
    {
        "id":  "shield-of-law",
        "name":  {
                     "ru":  "Щит закона",
                     "en":  "Shield of Law"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shieldOfLaw",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shieldOfLaw.html#shield-of-law"
                          }
    },
    {
        "id":  "inflict-moderate-wounds-mass",
        "name":  {
                     "ru":  "Исцеление серьезных ранений",
                     "en":  "Inflict Moderate Wounds, Mass"
                 },
        "classLevels":  {
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureModerateWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureModerateWounds.html#cure-moderate-wounds-mass"
                          }
    },
    {
        "id":  "reincarnate",
        "name":  {
                     "ru":  "Реинкарнация",
                     "en":  "Reincarnate"
                 },
        "classLevels":  {
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/reincarnate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/reincarnate.html#reincarnate"
                          }
    },
    {
        "id":  "heroism",
        "name":  {
                     "ru":  "Героизм",
                     "en":  "Heroism"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/heroism",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/heroism.html#heroism"
                          }
    },
    {
        "id":  "find-traps",
        "name":  {
                     "ru":  "Обнаружение ловушек",
                     "en":  "Find Traps"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/findTraps",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/findTraps.html#find-traps"
                          }
    },
    {
        "id":  "mage-armor",
        "name":  {
                     "ru":  "Магический доспех",
                     "en":  "Mage Armor"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageArmor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageArmor.html#mage-armor"
                          }
    },
    {
        "id":  "haste",
        "name":  {
                     "ru":  "Ускорение",
                     "en":  "Haste"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/haste",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/haste.html#haste"
                          }
    },
    {
        "id":  "shadow-conjuration-greater",
        "name":  {
                     "ru":  "Теневое воплощение",
                     "en":  "Shadow Conjuration, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shadowConjuration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shadowConjuration.html#shadow-conjuration-greater"
                          }
    },
    {
        "id":  "limited-wish",
        "name":  {
                     "ru":  "Ограниченное желание",
                     "en":  "Limited Wish"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/limitedWish",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/limitedWish.html#limited-wish"
                          }
    },
    {
        "id":  "heat-metal",
        "name":  {
                     "ru":  "Раскаленный металл",
                     "en":  "Heat Metal"
                 },
        "classLevels":  {
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/heatMetal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/heatMetal.html#heat-metal"
                          }
    },
    {
        "id":  "breath-of-life",
        "name":  {
                     "ru":  "Дыхание жизни",
                     "en":  "Breath of Life"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/breathOfLife",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/breathOfLife.html#breath-of-life"
                          }
    },
    {
        "id":  "divine-favor",
        "name":  {
                     "ru":  "Милость божества",
                     "en":  "Divine Favor"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/divineFavor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/divineFavor.html#divine-favor"
                          }
    },
    {
        "id":  "summon-monster-iii",
        "name":  {
                     "ru":  "Призыв чудовища III",
                     "en":  "Summon Monster III"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Cleric":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-iii"
                          }
    },
    {
        "id":  "plant-shape-i",
        "name":  {
                     "ru":  "Облик растения I",
                     "en":  "Plant Shape I"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/plantShapeI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/plantShape.html#plant-shape-i"
                          }
    },
    {
        "id":  "refuge",
        "name":  {
                     "ru":  "Пристанище",
                     "en":  "Refuge"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/refuge",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/refuge.html#refuge"
                          }
    },
    {
        "id":  "alter-self",
        "name":  {
                     "ru":  "Иной облик",
                     "en":  "Alter Self"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/alterSelf",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/alterSelf.html#alter-self"
                          }
    },
    {
        "id":  "glyph-of-warding-greater",
        "name":  {
                     "ru":  "Сторожевая печать",
                     "en":  "Glyph of Warding, Greater"
                 },
        "classLevels":  {
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/glyphOfWarding",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/glyphOfWarding.html#glyph-of-warding-greater"
                          }
    },
    {
        "id":  "spell-immunity-greater",
        "name":  {
                     "ru":  "Невосприимчивость к заклинаниям",
                     "en":  "Spell Immunity, Greater"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spellImmunity",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spellImmunity.html#spell-immunity-greater"
                          }
    },
    {
        "id":  "deep-slumber",
        "name":  {
                     "ru":  "Глубокий сон",
                     "en":  "Deep Slumber"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/deepSlumber",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/deepSlumber.html#deep-slumber"
                          }
    },
    {
        "id":  "teleport-greater",
        "name":  {
                     "ru":  "Телепортация",
                     "en":  "Teleport, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/teleport",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/teleport.html#teleport-greater"
                          }
    },
    {
        "id":  "dream",
        "name":  {
                     "ru":  "Сновидение",
                     "en":  "Dream"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dream",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dream.html#dream"
                          }
    },
    {
        "id":  "explosive-runes",
        "name":  {
                     "ru":  "Взрывчатые руны",
                     "en":  "Explosive Runes"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/explosiveRunes",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/explosiveRunes.html#explosive-runes"
                          }
    },
    {
        "id":  "doom",
        "name":  {
                     "ru":  "Погибель",
                     "en":  "Doom"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/doom",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/doom.html#doom"
                          }
    },
    {
        "id":  "dimensional-lock",
        "name":  {
                     "ru":  "Пространственная преграда",
                     "en":  "Dimensional Lock"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dimensionalLock",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dimensionalLock.html#dimensional-lock"
                          }
    },
    {
        "id":  "owl-s-wisdom-mass",
        "name":  {
                     "ru":  "Совиная мудрость",
                     "en":  "Owl\u0027s Wisdom, Mass"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/owlWisdom",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/owlSWisdom.html#owl-s-wisdom-mass"
                          }
    },
    {
        "id":  "baleful-polymorph",
        "name":  {
                     "ru":  "Губительный полиморф",
                     "en":  "Baleful Polymorph"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/balefulPolymorph",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/balefulPolymorph.html#baleful-polymorph"
                          }
    },
    {
        "id":  "slow",
        "name":  {
                     "ru":  "Замедление",
                     "en":  "Slow"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/slow",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/slow.html#slow"
                          }
    },
    {
        "id":  "command-plants",
        "name":  {
                     "ru":  "Управление растениями",
                     "en":  "Command Plants"
                 },
        "classLevels":  {
                            "Druid":  4,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/commandPlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/commandPlants.html#command-plants"
                          }
    },
    {
        "id":  "locate-creature",
        "name":  {
                     "ru":  "Поиск существа",
                     "en":  "Locate Creature"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/locateCreature",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/locateCreature.html#locate-creature"
                          }
    },
    {
        "id":  "waves-of-fatigue",
        "name":  {
                     "ru":  "Волна усталости",
                     "en":  "Waves of Fatigue"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fatigueWaves",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wavesOfFatigue.html#waves-of-fatigue"
                          }
    },
    {
        "id":  "hideous-laughter",
        "name":  {
                     "ru":  "Безудержный смех",
                     "en":  "Hideous Laughter"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hideousLaughter",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hideousLaughter.html#hideous-laughter"
                          }
    },
    {
        "id":  "spell-turning",
        "name":  {
                     "ru":  "Отражение заклинаний",
                     "en":  "Spell Turning"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spellTurning",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spellTurning.html#spell-turning"
                          }
    },
    {
        "id":  "wall-of-force",
        "name":  {
                     "ru":  "Силовая стена",
                     "en":  "Wall of Force"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wallOfForce",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wallOfForce.html#wall-of-force"
                          }
    },
    {
        "id":  "rusting-grasp",
        "name":  {
                     "ru":  "Ржавящее прикосновение",
                     "en":  "Rusting Grasp"
                 },
        "classLevels":  {
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/rustingGrasp",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/rustingGrasp.html#rusting-grasp"
                          }
    },
    {
        "id":  "repel-metal-or-stone",
        "name":  {
                     "ru":  "Отталкивание камня и металла",
                     "en":  "Repel Metal or Stone"
                 },
        "classLevels":  {
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/repelMetalOrStone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/repelMetalOrStone.html#repel-metal-or-stone"
                          }
    },
    {
        "id":  "shrink-item",
        "name":  {
                     "ru":  "Уменьшение предмета",
                     "en":  "Shrink Item"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shrinkItem",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shrinkItem.html#shrink-item"
                          }
    },
    {
        "id":  "foresight",
        "name":  {
                     "ru":  "Видение будущего",
                     "en":  "Foresight"
                 },
        "classLevels":  {
                            "Druid":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/foresight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/foresight.html#foresight"
                          }
    },
    {
        "id":  "sympathy",
        "name":  {
                     "ru":  "Симпатия",
                     "en":  "Sympathy"
                 },
        "classLevels":  {
                            "Druid":  9,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sympathy",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sympathy.html#sympathy"
                          }
    },
    {
        "id":  "bless-water",
        "name":  {
                     "ru":  "Освящение воды",
                     "en":  "Bless Water"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blessWater",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blessWater.html#bless-water"
                          }
    },
    {
        "id":  "control-weather",
        "name":  {
                     "ru":  "Управление погодой",
                     "en":  "Control Weather"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Druid":  7,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/controlWeather",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/controlWeather.html#control-weather"
                          }
    },
    {
        "id":  "commune",
        "name":  {
                     "ru":  "Божественное откровение",
                     "en":  "Commune"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/commune",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/commune.html#commune"
                          }
    },
    {
        "id":  "phase-door",
        "name":  {
                     "ru":  "Эфирная дверь",
                     "en":  "Phase Door"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/phaseDoor",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/phaseDoor.html#phase-door"
                          }
    },
    {
        "id":  "spike-stones",
        "name":  {
                     "ru":  "Шипастые камни",
                     "en":  "Spike Stones"
                 },
        "classLevels":  {
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spikeStones",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spikeStones.html#spike-stones"
                          }
    },
    {
        "id":  "wall-of-stone",
        "name":  {
                     "ru":  "Каменная стена",
                     "en":  "Wall of Stone"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Druid":  6,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wallOfStone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wallOfStone.html#wall-of-stone"
                          }
    },
    {
        "id":  "bear-s-endurance",
        "name":  {
                     "ru":  "Медвежья стойкость",
                     "en":  "Bear\u0027s Endurance"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Druid":  2,
                            "Ranger":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bearEndurance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bearSEndurance.html#bear-s-endurance"
                          }
    },
    {
        "id":  "tongues",
        "name":  {
                     "ru":  "Полиглот",
                     "en":  "Tongues"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  4,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/tongues",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/tongues.html#tongues"
                          }
    },
    {
        "id":  "charm-monster-mass",
        "name":  {
                     "ru":  "Приворот (чудовище)",
                     "en":  "Charm Monster, Mass"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/charmMonster",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/charmMonster.html#charm-monster-mass"
                          }
    },
    {
        "id":  "ice-storm",
        "name":  {
                     "ru":  "Ледяная буря",
                     "en":  "Ice Storm"
                 },
        "classLevels":  {
                            "Druid":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/iceStorm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/iceStorm.html#ice-storm"
                          }
    },
    {
        "id":  "crushing-hand",
        "name":  {
                     "ru":  "Сокрушительная рука",
                     "en":  "Crushing Hand"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/crushingHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/crushingHand.html#crushing-hand"
                          }
    },
    {
        "id":  "antimagic-field",
        "name":  {
                     "ru":  "Поле антимагии",
                     "en":  "Antimagic Field"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/antimagicField",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/antimagicField.html#antimagic-field"
                          }
    },
    {
        "id":  "detect-snares-and-pits",
        "name":  {
                     "ru":  "Обнаружение силков и ям",
                     "en":  "Detect Snares and Pits"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectSnaresAndPits",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectSnaresAndPits.html#detect-snares-and-pits"
                          }
    },
    {
        "id":  "bless",
        "name":  {
                     "ru":  "Благословение",
                     "en":  "Bless"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bless",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bless.html#bless"
                          }
    },
    {
        "id":  "create-greater-undead",
        "name":  {
                     "ru":  "Создание высшей нежити",
                     "en":  "Create Greater Undead"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/createGreaterUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/createGreaterUndead.html#create-greater-undead"
                          }
    },
    {
        "id":  "identify",
        "name":  {
                     "ru":  "Опознание",
                     "en":  "Identify"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/identify",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/identify.html#identify"
                          }
    },
    {
        "id":  "awaken",
        "name":  {
                     "ru":  "Пробуждение",
                     "en":  "Awaken"
                 },
        "classLevels":  {
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/awaken",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/awaken.html#awaken"
                          }
    },
    {
        "id":  "insanity",
        "name":  {
                     "ru":  "Безумие",
                     "en":  "Insanity"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/insanity",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/insanity.html#insanity"
                          }
    },
    {
        "id":  "demand",
        "name":  {
                     "ru":  "Требование",
                     "en":  "Demand"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/demand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/demand.html#demand"
                          }
    },
    {
        "id":  "cure-critical-wounds-mass",
        "name":  {
                     "ru":  "Исцеление критических ранений",
                     "en":  "Cure Critical Wounds, Mass"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Druid":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureCriticalWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureCriticalWounds.html#cure-critical-wounds-mass"
                          }
    },
    {
        "id":  "scare",
        "name":  {
                     "ru":  "Страх",
                     "en":  "Scare"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/scare",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/scare.html#scare"
                          }
    },
    {
        "id":  "inflict-critical-wounds",
        "name":  {
                     "ru":  "Нанесение критических ранений",
                     "en":  "Inflict Critical Wounds"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictCriticalWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictCriticalWounds.html#inflict-critical-wounds"
                          }
    },
    {
        "id":  "power-word-stun",
        "name":  {
                     "ru":  "Слово силы: шок",
                     "en":  "Power Word Stun"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/powerWordStun",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/powerWordStun.html#power-word-stun"
                          }
    },
    {
        "id":  "zone-of-truth",
        "name":  {
                     "ru":  "Место истины",
                     "en":  "Zone of Truth"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Paladin":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/zoneOfTruth",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/zoneOfTruth.html#zone-of-truth"
                          }
    },
    {
        "id":  "cone-of-cold",
        "name":  {
                     "ru":  "Конус холода",
                     "en":  "Cone of Cold"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/coneOfCold",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/coneOfCold.html#cone-of-cold"
                          }
    },
    {
        "id":  "phantom-trap",
        "name":  {
                     "ru":  "Фантомная ловушка",
                     "en":  "Phantom Trap"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/phantomTrap",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/phantomTrap.html#phantom-trap"
                          }
    },
    {
        "id":  "mislead",
        "name":  {
                     "ru":  "Обманка",
                     "en":  "Mislead"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mislead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mislead.html#mislead"
                          }
    },
    {
        "id":  "prismatic-wall",
        "name":  {
                     "ru":  "Радужная стена",
                     "en":  "Prismatic Wall"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/prismaticWall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/prismaticWall.html#prismatic-wall"
                          }
    },
    {
        "id":  "status",
        "name":  {
                     "ru":  "Состояние",
                     "en":  "Status"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/status",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/status.html#status"
                          }
    },
    {
        "id":  "call-lightning",
        "name":  {
                     "ru":  "Вызов молний",
                     "en":  "Call Lightning"
                 },
        "classLevels":  {
                            "Druid":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/callLightning",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/callLightning.html#call-lightning"
                          }
    },
    {
        "id":  "quench",
        "name":  {
                     "ru":  "Тушение",
                     "en":  "Quench"
                 },
        "classLevels":  {
                            "Druid":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/quench",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/quench.html#quench"
                          }
    },
    {
        "id":  "temporal-stasis",
        "name":  {
                     "ru":  "Стазис",
                     "en":  "Temporal Stasis"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/temporalStasis",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/temporalStasis.html#temporal-stasis"
                          }
    },
    {
        "id":  "deathwatch",
        "name":  {
                     "ru":  "Зрение некроманта",
                     "en":  "Deathwatch"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/deathwatch",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/deathwatch.html"
                          }
    },
    {
        "id":  "command-undead",
        "name":  {
                     "ru":  "Управление нежитью",
                     "en":  "Command Undead"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/commandUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/commandUndead.html#command-undead"
                          }
    },
    {
        "id":  "mount",
        "name":  {
                     "ru":  "Скакун",
                     "en":  "Mount"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mount",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mount.html#mount"
                          }
    },
    {
        "id":  "weird",
        "name":  {
                     "ru":  "Жуть",
                     "en":  "Weird"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/weird",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/weird.html#weird"
                          }
    },
    {
        "id":  "forbiddance",
        "name":  {
                     "ru":  "Запрет",
                     "en":  "Forbiddance"
                 },
        "classLevels":  {
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/forbiddance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/forbiddance.html#forbiddance"
                          }
    },
    {
        "id":  "discern-lies",
        "name":  {
                     "ru":  "Выявление лжи",
                     "en":  "Discern Lies"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Paladin":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/discernLies",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/discernLies.html#discern-lies"
                          }
    },
    {
        "id":  "charm-person",
        "name":  {
                     "ru":  "Приворот (гуманоид)",
                     "en":  "Charm Person"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/charmPerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/charmPerson.html#charm-person"
                          }
    },
    {
        "id":  "faerie-fire",
        "name":  {
                     "ru":  "Фейское сияние",
                     "en":  "Faerie Fire"
                 },
        "classLevels":  {
                            "Druid":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/faerieFire",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/faerieFire.html#faerie-fire"
                          }
    },
    {
        "id":  "detect-scrying",
        "name":  {
                     "ru":  "Обнаружение слежки",
                     "en":  "Detect Scrying"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectScrying",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectScrying.html#detect-scrying"
                          }
    },
    {
        "id":  "cure-moderate-wounds-mass",
        "name":  {
                     "ru":  "Исцеление серьезных ранений",
                     "en":  "Cure Moderate Wounds, Mass"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6,
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureModerateWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureModerateWounds.html#cure-moderate-wounds-mass"
                          }
    },
    {
        "id":  "eyebite",
        "name":  {
                     "ru":  "Грозные очи",
                     "en":  "Eyebite"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/eyebite",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/eyebite.html#eyebite"
                          }
    },
    {
        "id":  "hold-person",
        "name":  {
                     "ru":  "Паралич (гуманоид)",
                     "en":  "Hold Person"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holdPerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holdPerson.html#hold-person"
                          }
    },
    {
        "id":  "sympathetic-vibration",
        "name":  {
                     "ru":  "Резонанс",
                     "en":  "Sympathetic Vibration"
                 },
        "classLevels":  {
                            "Bard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sympatheticVibration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sympatheticVibration.html#sympathetic-vibration"
                          }
    },
    {
        "id":  "death-knell",
        "name":  {
                     "ru":  "Погребальный звон",
                     "en":  "Death Knell"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/deathKnell",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/deathKnell.html#death-knell"
                          }
    },
    {
        "id":  "summon-monster-v",
        "name":  {
                     "ru":  "Призыв чудовища V",
                     "en":  "Summon Monster V"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Cleric":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterV",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-v"
                          }
    },
    {
        "id":  "animate-rope",
        "name":  {
                     "ru":  "Оживить веревку",
                     "en":  "Animate Rope"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animateRope",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animateRope.html#animate-rope"
                          }
    },
    {
        "id":  "protection-from-chaos-evil",
        "name":  {
                     "ru":  "Защита от зла",
                     "en":  "Protection from Chaos/Evil"
                 },
        "classLevels":  {
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/protectionFromEvil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/protectionFromEvil.html#protection-from-evil"
                          }
    },
    {
        "id":  "wind-wall",
        "name":  {
                     "ru":  "Стена ветра",
                     "en":  "Wind Wall"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3,
                            "Ranger":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/windWall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/windWall.html#wind-wall"
                          }
    },
    {
        "id":  "longstrider",
        "name":  {
                     "ru":  "Скороход",
                     "en":  "Longstrider"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/longstrider",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/longstrider.html#longstrider"
                          }
    },
    {
        "id":  "forcecage",
        "name":  {
                     "ru":  "Силовая клетка",
                     "en":  "Forcecage"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/forcecage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/forcecage.html#forcecage"
                          }
    },
    {
        "id":  "dispel-evil",
        "name":  {
                     "ru":  "Рассеивание зла",
                     "en":  "Dispel Evil"
                 },
        "classLevels":  {
                            "Paladin":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dispelEvil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dispelEvil.html#dispel-evil"
                          }
    },
    {
        "id":  "moment-of-prescience",
        "name":  {
                     "ru":  "Миг предвидения",
                     "en":  "Moment of Prescience"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/momentOfPrescience",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/momentOfPrescience.html#moment-of-prescience"
                          }
    },
    {
        "id":  "animate-objects",
        "name":  {
                     "ru":  "Оживить предметы",
                     "en":  "Animate Objects"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animateObjects",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animateObjects.html#animate-objects"
                          }
    },
    {
        "id":  "chain-lightning",
        "name":  {
                     "ru":  "Цепь молний",
                     "en":  "Chain Lightning"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/chainLightning",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/chainLightning.html#chain-lightning"
                          }
    },
    {
        "id":  "inflict-serious-wounds-mass",
        "name":  {
                     "ru":  "Нанесение тяжелых ранений",
                     "en":  "Inflict Serious Wounds, Mass"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictSeriousWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictSeriousWounds.html#inflict-serious-wounds-mass"
                          }
    },
    {
        "id":  "disguise-self",
        "name":  {
                     "ru":  "Изменение облика",
                     "en":  "Disguise Self"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/disguiseSelf",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/disguiseSelf.html#disguise-self"
                          }
    },
    {
        "id":  "water-breathing",
        "name":  {
                     "ru":  "Дыхание под водой",
                     "en":  "Water Breathing"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/waterBreathing",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/waterBreathing.html#water-breathing"
                          }
    },
    {
        "id":  "wish",
        "name":  {
                     "ru":  "Желание",
                     "en":  "Wish"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wish",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wish.html#wish"
                          }
    },
    {
        "id":  "summon-monster-ii",
        "name":  {
                     "ru":  "Призыв чудовища II",
                     "en":  "Summon Monster II"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-ii"
                          }
    },
    {
        "id":  "gaseous-form",
        "name":  {
                     "ru":  "Газообразность",
                     "en":  "Gaseous Form"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/gaseousForm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/gaseousForm.html#gaseous-form"
                          }
    },
    {
        "id":  "wall-of-thorns",
        "name":  {
                     "ru":  "Терновая стена",
                     "en":  "Wall of Thorns"
                 },
        "classLevels":  {
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wallOfThorns",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wallOfThorns.html#wall-of-thorns"
                          }
    },
    {
        "id":  "feather-fall",
        "name":  {
                     "ru":  "Плавное падение",
                     "en":  "Feather Fall"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/featherFall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/featherFall.html#feather-fall"
                          }
    },
    {
        "id":  "secure-shelter",
        "name":  {
                     "ru":  "Надежное укрытие",
                     "en":  "Secure Shelter"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/secureShelter",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/secureShelter.html#secure-shelter"
                          }
    },
    {
        "id":  "summon-swarm",
        "name":  {
                     "ru":  "Призыв стаи тварей",
                     "en":  "Summon Swarm"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Druid":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonSwarm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonSwarm.html#summon-swarm"
                          }
    },
    {
        "id":  "magic-jar",
        "name":  {
                     "ru":  "Колдовской сосуд",
                     "en":  "Magic Jar"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicJar",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicJar.html#magic-jar"
                          }
    },
    {
        "id":  "whirlwind",
        "name":  {
                     "ru":  "Вихрь",
                     "en":  "Whirlwind"
                 },
        "classLevels":  {
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/whirlwind",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/whirlwind.html#whirlwind"
                          }
    },
    {
        "id":  "acid-fog",
        "name":  {
                     "ru":  "Кислотный туман",
                     "en":  "Acid Fog"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/acidFog",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/acidFog.html#acid-fog"
                          }
    },
    {
        "id":  "scrying-greater",
        "name":  {
                     "ru":  "Тайновидение",
                     "en":  "Scrying, Greater"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  7,
                            "Druid":  7,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/scrying",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/scrying.html#scrying-greater"
                          }
    },
    {
        "id":  "bane",
        "name":  {
                     "ru":  "Отповедь",
                     "en":  "Bane"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bane",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bane.html#bane"
                          }
    },
    {
        "id":  "erase",
        "name":  {
                     "ru":  "Стирание",
                     "en":  "Erase"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/erase",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/erase.html#erase"
                          }
    },
    {
        "id":  "fly",
        "name":  {
                     "ru":  "Полет",
                     "en":  "Fly"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fly",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fly.html"
                          }
    },
    {
        "id":  "magic-mouth",
        "name":  {
                     "ru":  "Волшебный рот",
                     "en":  "Magic Mouth"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicMouth",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicMouth.html#magic-mouth"
                          }
    },
    {
        "id":  "fire-storm",
        "name":  {
                     "ru":  "Огненная буря",
                     "en":  "Fire Storm"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fireStorm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fireStorm.html#fire-storm"
                          }
    },
    {
        "id":  "secret-chest",
        "name":  {
                     "ru":  "Потайной сундук",
                     "en":  "Secret Chest"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/secretChest",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/secretChest.html#secret-chest"
                          }
    },
    {
        "id":  "misdirection",
        "name":  {
                     "ru":  "Перенаправление",
                     "en":  "Misdirection"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/misdirection",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/misdirection.html#misdirection"
                          }
    },
    {
        "id":  "summon-monster-ix",
        "name":  {
                     "ru":  "Призыв чудовища IX",
                     "en":  "Summon Monster IX"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterIX",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-ix"
                          }
    },
    {
        "id":  "levitate",
        "name":  {
                     "ru":  "Левитация",
                     "en":  "Levitate"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/levitate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/levitate.html#levitate"
                          }
    },
    {
        "id":  "instant-summons",
        "name":  {
                     "ru":  "Мгновенный призыв",
                     "en":  "Instant Summons"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/instantSummons",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/instantSummons.html#instant-summons"
                          }
    },
    {
        "id":  "mage-s-private-sanctum",
        "name":  {
                     "ru":  "Кабинет волшебника",
                     "en":  "Mage\u0027s Private Sanctum"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magePrivateSanctum",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageSPrivateSanctum.html#mage-s-private-sanctum"
                          }
    },
    {
        "id":  "flaming-sphere",
        "name":  {
                     "ru":  "Пылающая сфера",
                     "en":  "Flaming Sphere"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/flamingSphere",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/flamingSphere.html#flaming-sphere"
                          }
    },
    {
        "id":  "creeping-doom",
        "name":  {
                     "ru":  "Ползучая погибель",
                     "en":  "Creeping Doom"
                 },
        "classLevels":  {
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/creepingDoom",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/creepingDoom.html#creeping-doom"
                          }
    },
    {
        "id":  "consecrate",
        "name":  {
                     "ru":  "Освящение",
                     "en":  "Consecrate"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/consecrate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/consecrate.html#consecrate"
                          }
    },
    {
        "id":  "hide-from-animals",
        "name":  {
                     "ru":  "Невидимость для животных",
                     "en":  "Hide from Animals"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hideFromAnimals",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hideFromAnimals.html#hide-from-animals"
                          }
    },
    {
        "id":  "hold-monster",
        "name":  {
                     "ru":  "Паралич (чудовище)",
                     "en":  "Hold Monster"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holdMonster",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holdMonster.html#hold-monster"
                          }
    },
    {
        "id":  "ethereal-jaunt",
        "name":  {
                     "ru":  "Эфирная прогулка",
                     "en":  "Ethereal Jaunt"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/etherealJaunt",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/etherealJaunt.html#ethereal-jaunt"
                          }
    },
    {
        "id":  "resistance",
        "name":  {
                     "ru":  "Сопротивляемость",
                     "en":  "Resistance"
                 },
        "classLevels":  {
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/resistance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/resistance.html#resistance"
                          }
    },
    {
        "id":  "sound-burst",
        "name":  {
                     "ru":  "Раскат грома",
                     "en":  "Sound Burst"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/soundBurst",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/soundBurst.html#sound-burst"
                          }
    },
    {
        "id":  "vision",
        "name":  {
                     "ru":  "Видение",
                     "en":  "Vision"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/vision",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/vision.html#vision"
                          }
    },
    {
        "id":  "shillelagh",
        "name":  {
                     "ru":  "Шиллейла",
                     "en":  "Shillelagh"
                 },
        "classLevels":  {
                            "Druid":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shillelagh",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shillelagh.html#shillelagh"
                          }
    },
    {
        "id":  "remove-disease",
        "name":  {
                     "ru":  "Исцеление от болезней",
                     "en":  "Remove Disease"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/removeDisease",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/removeDisease.html#remove-disease"
                          }
    },
    {
        "id":  "true-strike",
        "name":  {
                     "ru":  "Верный удар",
                     "en":  "True Strike"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/trueStrike",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/trueStrike.html#true-strike"
                          }
    },
    {
        "id":  "magic-circle-against-chaos-evil",
        "name":  {
                     "ru":  "Магический круг против зла",
                     "en":  "Magic Circle against Chaos/Evil"
                 },
        "classLevels":  {
                            "Paladin":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicCircleAgainstEvil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicCircleAgainstEvil.html#magic-circle-against-evil"
                          }
    },
    {
        "id":  "magic-stone",
        "name":  {
                     "ru":  "Волшебный камень",
                     "en":  "Magic Stone"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Druid":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicStone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicStone.html#magic-stone"
                          }
    },
    {
        "id":  "hold-person-mass",
        "name":  {
                     "ru":  "Паралич (гуманоид)",
                     "en":  "Hold Person, Mass"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holdPerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holdPerson.html#hold-person-mass"
                          }
    },
    {
        "id":  "protection-from-chaos-evil-good-law",
        "name":  {
                     "ru":  "Защита от зла",
                     "en":  "Protection from Chaos/Evil/Good/Law"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/protectionFromEvil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/protectionFromEvil.html#protection-from-evil"
                          }
    },
    {
        "id":  "resist-energy",
        "name":  {
                     "ru":  "Устойчивость к стихии",
                     "en":  "Resist Energy"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Druid":  2,
                            "Paladin":  2,
                            "Ranger":  1,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/resistEnergy",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/resistEnergy.html#resist-energy"
                          }
    },
    {
        "id":  "shadow-walk",
        "name":  {
                     "ru":  "Путь в тенях",
                     "en":  "Shadow Walk"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shadowWalk",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shadowWalk.html#shadow-walk"
                          }
    },
    {
        "id":  "mage-s-faithful-hound",
        "name":  {
                     "ru":  "Верный пес волшебника",
                     "en":  "Mage\u0027s Faithful Hound"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageFaithfulHound",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageSFaithfulHound.html#mage-s-faithful-hound"
                          }
    },
    {
        "id":  "gate",
        "name":  {
                     "ru":  "Врата",
                     "en":  "Gate"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/gate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/gate.html#gate"
                          }
    },
    {
        "id":  "move-earth",
        "name":  {
                     "ru":  "Движение грунта",
                     "en":  "Move Earth"
                 },
        "classLevels":  {
                            "Druid":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/moveEarth",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/moveEarth.html#move-earth"
                          }
    },
    {
        "id":  "symbol-of-sleep",
        "name":  {
                     "ru":  "Символ сна",
                     "en":  "Symbol of Sleep"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfSleep",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfSleep.html#symbol-of-sleep"
                          }
    },
    {
        "id":  "wail-of-the-banshee",
        "name":  {
                     "ru":  "Вой баньши",
                     "en":  "Wail of the Banshee"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bansheeWail",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wailOfTheBanshee.html#wail-of-the-banshee"
                          }
    },
    {
        "id":  "incendiary-cloud",
        "name":  {
                     "ru":  "Горючее облако",
                     "en":  "Incendiary Cloud"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/incendiaryCloud",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/incendiaryCloud.html#incendiary-cloud"
                          }
    },
    {
        "id":  "word-of-chaos",
        "name":  {
                     "ru":  "Слово хаоса",
                     "en":  "Word of Chaos"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wordOfChaos",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wordOfChaos.html#word-of-chaos"
                          }
    },
    {
        "id":  "sending",
        "name":  {
                     "ru":  "Послание",
                     "en":  "Sending"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sending",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sending.html#sending"
                          }
    },
    {
        "id":  "fireball",
        "name":  {
                     "ru":  "Огненный шар",
                     "en":  "Fireball"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fireball",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fireball.html#fireball"
                          }
    },
    {
        "id":  "break-enchantment",
        "name":  {
                     "ru":  "Разрушение чар",
                     "en":  "Break Enchantment"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Cleric":  5,
                            "Paladin":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/breakEnchantment",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/breakEnchantment.html#break-enchantment"
                          }
    },
    {
        "id":  "antipathy",
        "name":  {
                     "ru":  "Антипатия",
                     "en":  "Antipathy"
                 },
        "classLevels":  {
                            "Druid":  9,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/antipathy",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/antipathy.html#antipathy"
                          }
    },
    {
        "id":  "spike-growth",
        "name":  {
                     "ru":  "Шипастая поросль",
                     "en":  "Spike Growth"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spikeGrowth",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spikeGrowth.html#spike-growth"
                          }
    },
    {
        "id":  "dictum",
        "name":  {
                     "ru":  "Вердикт",
                     "en":  "Dictum"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dictum",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dictum.html#dictum"
                          }
    },
    {
        "id":  "teleport-object",
        "name":  {
                     "ru":  "Телепортация предмета",
                     "en":  "Teleport Object"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/teleportObject",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/teleportObject.html#teleport-object"
                          }
    },
    {
        "id":  "call-lightning-storm",
        "name":  {
                     "ru":  "Вызов грозы",
                     "en":  "Call Lightning Storm"
                 },
        "classLevels":  {
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/callLightningStorm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/callLightningStorm.html#call-lightning-storm"
                          }
    },
    {
        "id":  "zone-of-silence",
        "name":  {
                     "ru":  "Укромное место",
                     "en":  "Zone of Silence"
                 },
        "classLevels":  {
                            "Bard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/zoneOfSilence",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/zoneOfSilence.html#zone-of-silence"
                          }
    },
    {
        "id":  "polymorph-greater",
        "name":  {
                     "ru":  "Полиморф",
                     "en":  "Polymorph, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/polymorph",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/polymorph.html#polymorph-greater"
                          }
    },
    {
        "id":  "repel-wood",
        "name":  {
                     "ru":  "Отталкивание дерева",
                     "en":  "Repel Wood"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/repelWood",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/repelWood.html#repel-wood"
                          }
    },
    {
        "id":  "elemental-body-ii",
        "name":  {
                     "ru":  "Стихийная форма II",
                     "en":  "Elemental Body II"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/elementalBodyII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/elementalBody.html#elemental-body-ii"
                          }
    },
    {
        "id":  "neutralize-poison",
        "name":  {
                     "ru":  "Нейтрализация яда",
                     "en":  "Neutralize Poison"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Cleric":  4,
                            "Druid":  3,
                            "Paladin":  4,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/neutralizePoison",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/neutralizePoison.html#neutralize-poison"
                          }
    },
    {
        "id":  "suggestion",
        "name":  {
                     "ru":  "Внушение",
                     "en":  "Suggestion"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/suggestion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/suggestion.html#suggestion"
                          }
    },
    {
        "id":  "undeath-to-death",
        "name":  {
                     "ru":  "Упокоение нежити",
                     "en":  "Undeath to Death"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/undeathToDeath",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/undeathToDeath.html#undeath-to-death"
                          }
    },
    {
        "id":  "jump",
        "name":  {
                     "ru":  "Прыжок",
                     "en":  "Jump"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/jump",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/jump.html#jump"
                          }
    },
    {
        "id":  "confusion",
        "name":  {
                     "ru":  "Замешательство",
                     "en":  "Confusion"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/confusion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/confusion.html#confusion"
                          }
    },
    {
        "id":  "mirror-image",
        "name":  {
                     "ru":  "Зеркальное отражение",
                     "en":  "Mirror Image"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mirrorImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mirrorImage.html#mirror-image"
                          }
    },
    {
        "id":  "blade-barrier",
        "name":  {
                     "ru":  "Стена лезвий",
                     "en":  "Blade Barrier"
                 },
        "classLevels":  {
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bladeBarrier",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bladeBarrier.html#blade-barrier"
                          }
    },
    {
        "id":  "disintegrate",
        "name":  {
                     "ru":  "Дезинтеграция",
                     "en":  "Disintegrate"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/disintegrate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/disintegrate.html#disintegrate"
                          }
    },
    {
        "id":  "circle-of-death",
        "name":  {
                     "ru":  "Круг смерти",
                     "en":  "Circle of Death"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/circleOfDeath",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/circleOfDeath.html#circle-of-death"
                          }
    },
    {
        "id":  "form-of-the-dragon-ii",
        "name":  {
                     "ru":  "Облик дракона II",
                     "en":  "Form of the Dragon II"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dragonFormII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/formOfTheDragon.html#form-of-the-dragon-ii"
                          }
    },
    {
        "id":  "stone-tell",
        "name":  {
                     "ru":  "Разговор с камнями",
                     "en":  "Stone Tell"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stoneTell",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stoneTell.html#stone-tell"
                          }
    },
    {
        "id":  "imbue-with-spell-ability",
        "name":  {
                     "ru":  "Наделение чарами",
                     "en":  "Imbue with Spell Ability"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/imbueWithSpellAbility",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/imbueWithSpellAbility.html#imbue-with-spell-ability"
                          }
    },
    {
        "id":  "shadow-evocation",
        "name":  {
                     "ru":  "Теневое разрушение",
                     "en":  "Shadow Evocation"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shadowEvocation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shadowEvocation.html#shadow-evocation"
                          }
    },
    {
        "id":  "ray-of-enfeeblement",
        "name":  {
                     "ru":  "Ослабляющий луч",
                     "en":  "Ray of Enfeeblement"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/rayOfEnfeeblement",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/rayOfEnfeeblement.html#ray-of-enfeeblement"
                          }
    },
    {
        "id":  "helping-hand",
        "name":  {
                     "ru":  "Рука помощи",
                     "en":  "Helping Hand"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/helpingHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/helpingHand.html#helping-hand"
                          }
    },
    {
        "id":  "minor-creation",
        "name":  {
                     "ru":  "Малое созидание",
                     "en":  "Minor Creation"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/minorCreation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/minorCreation.html#minor-creation"
                          }
    },
    {
        "id":  "overland-flight",
        "name":  {
                     "ru":  "Дальний перелет",
                     "en":  "Overland Flight"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/overlandFlight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/overlandFlight.html#overland-flight"
                          }
    },
    {
        "id":  "fox-s-cunning-mass",
        "name":  {
                     "ru":  "Лисья хитрость",
                     "en":  "Fox\u0027s Cunning, Mass"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/foxCunning",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/foxSCunning.html#fox-s-cunning-mass"
                          }
    },
    {
        "id":  "holy-aura",
        "name":  {
                     "ru":  "Аура святости",
                     "en":  "Holy Aura"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holyAura",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holyAura.html#holy-aura"
                          }
    },
    {
        "id":  "mage-s-sword",
        "name":  {
                     "ru":  "Меч волшебника",
                     "en":  "Mage\u0027s Sword"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageSword",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageSSword.html#mage-s-sword"
                          }
    },
    {
        "id":  "detect-animals-or-plants",
        "name":  {
                     "ru":  "Обнаружение животных и растений",
                     "en":  "Detect Animals or Plants"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectAnimalsOrPlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectAnimalsOrPlants.html#detect-animals-or-plants"
                          }
    },
    {
        "id":  "fire-trap",
        "name":  {
                     "ru":  "Огненная ловушка",
                     "en":  "Fire Trap"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fireTrap",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fireTrap.html#fire-trap"
                          }
    },
    {
        "id":  "hallucinatory-terrain",
        "name":  {
                     "ru":  "Иллюзорная местность",
                     "en":  "Hallucinatory Terrain"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hallucinatoryTerrain",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hallucinatoryTerrain.html#hallucinatory-terrain"
                          }
    },
    {
        "id":  "arcane-sight-greater",
        "name":  {
                     "ru":  "Мистическое зрение",
                     "en":  "Arcane Sight, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/arcaneSight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/arcaneSight.html#arcane-sight-greater"
                          }
    },
    {
        "id":  "animal-shapes",
        "name":  {
                     "ru":  "Звериные облики",
                     "en":  "Animal Shapes"
                 },
        "classLevels":  {
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animalShapes",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animalShapes.html#animal-shapes"
                          }
    },
    {
        "id":  "charm-monster",
        "name":  {
                     "ru":  "Приворот (чудовище)",
                     "en":  "Charm Monster"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/charmMonster",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/charmMonster.html#charm-monster"
                          }
    },
    {
        "id":  "wind-walk",
        "name":  {
                     "ru":  "Путешествие с ветром",
                     "en":  "Wind Walk"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/windWalk",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/windWalk.html#wind-walk"
                          }
    },
    {
        "id":  "blink",
        "name":  {
                     "ru":  "Мерцание",
                     "en":  "Blink"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blink",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blink.html#blink"
                          }
    },
    {
        "id":  "bull-s-strength",
        "name":  {
                     "ru":  "Бычья сила",
                     "en":  "Bull\u0027s Strength"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Druid":  2,
                            "Paladin":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/bullStrength",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/bullSStrength.html#bull-s-strength"
                          }
    },
    {
        "id":  "grasping-hand",
        "name":  {
                     "ru":  "Хваткая рука",
                     "en":  "Grasping Hand"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/graspingHand",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/graspingHand.html#grasping-hand"
                          }
    },
    {
        "id":  "blindness-deafness",
        "name":  {
                     "ru":  "Слепота/глухота",
                     "en":  "Blindness/Deafness"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  3,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blindnessDeafness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blindnessDeafness.html#blindness-deafness"
                          }
    },
    {
        "id":  "color-spray",
        "name":  {
                     "ru":  "Цветные брызги",
                     "en":  "Color Spray"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/colorSpray",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/colorSpray.html#color-spray"
                          }
    },
    {
        "id":  "tree-shape",
        "name":  {
                     "ru":  "Облик дерева",
                     "en":  "Tree Shape"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/treeShape",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/treeShape.html#tree-shape"
                          }
    },
    {
        "id":  "arcane-sight",
        "name":  {
                     "ru":  "Мистическое зрение",
                     "en":  "Arcane Sight"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/arcaneSight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/arcaneSight.html#arcane-sight"
                          }
    },
    {
        "id":  "pass-without-trace",
        "name":  {
                     "ru":  "Бесследный шаг",
                     "en":  "Pass without Trace"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/passWithoutTrace",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/passWithoutTrace.html#pass-without-trace"
                          }
    },
    {
        "id":  "entropic-shield",
        "name":  {
                     "ru":  "Щит энтропии",
                     "en":  "Entropic Shield"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/entropicShield",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/entropicShield.html#entropic-shield"
                          }
    },
    {
        "id":  "sanctuary",
        "name":  {
                     "ru":  "Убежище",
                     "en":  "Sanctuary"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sanctuary",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sanctuary.html#sanctuary"
                          }
    },
    {
        "id":  "heal-mass",
        "name":  {
                     "ru":  "Излечение",
                     "en":  "Heal, Mass"
                 },
        "classLevels":  {
                            "Cleric":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/heal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/heal.html#heal-mass"
                          }
    },
    {
        "id":  "summon-nature-s-ally-v",
        "name":  {
                     "ru":  "Призыв природного союзника V",
                     "en":  "Summon Nature\u0027s Ally V"
                 },
        "classLevels":  {
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyV",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-v"
                          }
    },
    {
        "id":  "prying-eyes-greater",
        "name":  {
                     "ru":  "Глаза-разведчики",
                     "en":  "Prying Eyes, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/pryingEyes",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/pryingEyes.html#prying-eyes-greater"
                          }
    },
    {
        "id":  "summon-nature-s-ally-iv",
        "name":  {
                     "ru":  "Призыв природного союзника IV",
                     "en":  "Summon Nature\u0027s Ally IV"
                 },
        "classLevels":  {
                            "Druid":  4,
                            "Ranger":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyIV",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-iv"
                          }
    },
    {
        "id":  "miracle",
        "name":  {
                     "ru":  "Чудо",
                     "en":  "Miracle"
                 },
        "classLevels":  {
                            "Cleric":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/miracle",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/miracle.html#miracle"
                          }
    },
    {
        "id":  "gust-of-wind",
        "name":  {
                     "ru":  "Порыв ветра",
                     "en":  "Gust of Wind"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/gustOfWind",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/gustOfWind.html#gust-of-wind"
                          }
    },
    {
        "id":  "permanency",
        "name":  {
                     "ru":  "Постоянство",
                     "en":  "Permanency"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/permanency",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/permanency.html#permanency"
                          }
    },
    {
        "id":  "bless-weapon",
        "name":  {
                     "ru":  "Благословение оружия",
                     "en":  "Bless Weapon"
                 },
        "classLevels":  {
                            "Paladin":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/blessWeapon",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/blessWeapon.html#bless-weapon"
                          }
    },
    {
        "id":  "command-greater",
        "name":  {
                     "ru":  "Приказ",
                     "en":  "Command, Greater"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/command",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/command.html#command-greater"
                          }
    },
    {
        "id":  "plant-growth",
        "name":  {
                     "ru":  "Рост растений",
                     "en":  "Plant Growth"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/plantGrowth",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/plantGrowth.html#plant-growth"
                          }
    },
    {
        "id":  "glibness",
        "name":  {
                     "ru":  "Бойкий язык",
                     "en":  "Glibness"
                 },
        "classLevels":  {
                            "Bard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/glibness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/glibness.html#glibness"
                          }
    },
    {
        "id":  "plant-shape-ii",
        "name":  {
                     "ru":  "Облик растения II",
                     "en":  "Plant Shape II"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/plantShapeII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/plantShape.html#plant-shape-ii"
                          }
    },
    {
        "id":  "cloak-of-chaos",
        "name":  {
                     "ru":  "Покров хаоса",
                     "en":  "Cloak of Chaos"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cloakOfChaos",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cloakOfChaos.html#cloak-of-chaos"
                          }
    },
    {
        "id":  "finger-of-death",
        "name":  {
                     "ru":  "Палец смерти",
                     "en":  "Finger of Death"
                 },
        "classLevels":  {
                            "Druid":  8,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fingerOfDeath",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fingerOfDeath.html#finger-of-death"
                          }
    },
    {
        "id":  "sunburst",
        "name":  {
                     "ru":  "Солнечная вспышка",
                     "en":  "Sunburst"
                 },
        "classLevels":  {
                            "Druid":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sunburst",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sunburst.html#sunburst"
                          }
    },
    {
        "id":  "power-word-kill",
        "name":  {
                     "ru":  "Слово силы: смерть",
                     "en":  "Power Word Kill"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/powerWordKill",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/powerWordKill.html#power-word-kill"
                          }
    },
    {
        "id":  "goodberry",
        "name":  {
                     "ru":  "Вкусные ягоды",
                     "en":  "Goodberry"
                 },
        "classLevels":  {
                            "Druid":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/goodberry",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/goodberry.html#goodberry"
                          }
    },
    {
        "id":  "rage",
        "name":  {
                     "ru":  "Ярость",
                     "en":  "Rage"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/rage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/rage.html#rage"
                          }
    },
    {
        "id":  "veil",
        "name":  {
                     "ru":  "Вуаль",
                     "en":  "Veil"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/veil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/veil.html#veil"
                          }
    },
    {
        "id":  "alarm",
        "name":  {
                     "ru":  "Сигнал тревоги",
                     "en":  "Alarm"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Ranger":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/alarm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/alarm.html#alarm"
                          }
    },
    {
        "id":  "detect-secret-doors",
        "name":  {
                     "ru":  "Обнаружение тайных дверей",
                     "en":  "Detect Secret Doors"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/detectSecretDoors",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/detectSecretDoors.html#detect-secret-doors"
                          }
    },
    {
        "id":  "freezing-sphere",
        "name":  {
                     "ru":  "Морозный шар",
                     "en":  "Freezing Sphere"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/freezingSphere",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/freezingSphere.html#freezing-sphere"
                          }
    },
    {
        "id":  "horrid-wilting",
        "name":  {
                     "ru":  "Жуткое иссушение",
                     "en":  "Horrid Wilting"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/horridWilting",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/horridWilting.html#horrid-wilting"
                          }
    },
    {
        "id":  "calm-animals",
        "name":  {
                     "ru":  "Усмирение животных",
                     "en":  "Calm Animals"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/calmAnimals",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/calmAnimals.html#calm-animals"
                          }
    },
    {
        "id":  "warp-wood",
        "name":  {
                     "ru":  "Коробление",
                     "en":  "Warp Wood"
                 },
        "classLevels":  {
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/warpWood",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/warpWood.html#warp-wood"
                          }
    },
    {
        "id":  "polymorph-any-object",
        "name":  {
                     "ru":  "Универсальный полиморф",
                     "en":  "Polymorph Any Object"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/polymorphAnyObject",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/polymorphAnyObject.html#polymorph-any-object"
                          }
    },
    {
        "id":  "inflict-moderate-wounds",
        "name":  {
                     "ru":  "Нанесение серьезных ранений",
                     "en":  "Inflict Moderate Wounds"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictModerateWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictModerateWounds.html#inflict-moderate-wounds"
                          }
    },
    {
        "id":  "magic-fang",
        "name":  {
                     "ru":  "Волшебный клык",
                     "en":  "Magic Fang"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicFang",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicFang.html#magic-fang"
                          }
    },
    {
        "id":  "major-creation",
        "name":  {
                     "ru":  "Созидание, великое",
                     "en":  "Major Creation"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/majorCreation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/majorCreation.html#major-creation"
                          }
    },
    {
        "id":  "delayed-blast-fireball",
        "name":  {
                     "ru":  "Отложенный огненный шар",
                     "en":  "Delayed Blast Fireball"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/delayedBlastFireball",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/delayedBlastFireball.html#delayed-blast-fireball"
                          }
    },
    {
        "id":  "inflict-light-wounds-mass",
        "name":  {
                     "ru":  "Нанесение легких ранений",
                     "en":  "Inflict Light Wounds, Mass"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/inflictLightWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/inflictLightWounds.html#inflict-light-wounds-mass"
                          }
    },
    {
        "id":  "major-image",
        "name":  {
                     "ru":  "Полноценный образ",
                     "en":  "Major Image"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/majorImage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/majorImage.html#major-image"
                          }
    },
    {
        "id":  "illusory-wall",
        "name":  {
                     "ru":  "Иллюзорная стена",
                     "en":  "Illusory Wall"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/illusoryWall",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/illusoryWall.html#illusory-wall"
                          }
    },
    {
        "id":  "teleportation-circle",
        "name":  {
                     "ru":  "Телепортирующий круг",
                     "en":  "Teleportation Circle"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/teleportationCircle",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/teleportationCircle.html#teleportation-circle"
                          }
    },
    {
        "id":  "silence",
        "name":  {
                     "ru":  "Тишина",
                     "en":  "Silence"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/silence",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/silence.html#silence"
                          }
    },
    {
        "id":  "summon-monster-vi",
        "name":  {
                     "ru":  "Призыв чудовища VI",
                     "en":  "Summon Monster VI"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterVI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-vi"
                          }
    },
    {
        "id":  "diminish-plants",
        "name":  {
                     "ru":  "Угнетение растений",
                     "en":  "Diminish Plants"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/diminishPlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/diminishPlants.html#diminish-plants"
                          }
    },
    {
        "id":  "shout",
        "name":  {
                     "ru":  "Вопль",
                     "en":  "Shout"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shout",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shout.html#shout"
                          }
    },
    {
        "id":  "raise-dead",
        "name":  {
                     "ru":  "Возвращение к жизни",
                     "en":  "Raise Dead"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/raiseDead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/raiseDead.html#raise-dead"
                          }
    },
    {
        "id":  "etherealness",
        "name":  {
                     "ru":  "Выход в Эфир",
                     "en":  "Etherealness"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/etherealness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/etherealness.html#etherealness"
                          }
    },
    {
        "id":  "meteor-swarm",
        "name":  {
                     "ru":  "Метеориты",
                     "en":  "Meteor Swarm"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/meteorSwarm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/meteorSwarm.html#meteor-swarm"
                          }
    },
    {
        "id":  "dispel-magic-greater",
        "name":  {
                     "ru":  "Рассеивание магии",
                     "en":  "Dispel Magic, Greater"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Cleric":  6,
                            "Druid":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dispelMagic",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dispelMagic.html#dispel-magic-greater"
                          }
    },
    {
        "id":  "planar-ally",
        "name":  {
                     "ru":  "Потусторонний союзник",
                     "en":  "Planar Ally"
                 },
        "classLevels":  {
                            "Cleric":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planarAlly",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planarAlly.html#planar-ally"
                          }
    },
    {
        "id":  "planar-binding-greater",
        "name":  {
                     "ru":  "Потусторонний слуга",
                     "en":  "Planar Binding, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planarBinding",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planarBinding.html#planar-binding-greater"
                          }
    },
    {
        "id":  "trap-the-soul",
        "name":  {
                     "ru":  "Ловушка для души",
                     "en":  "Trap the Soul"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/trapTheSoul",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/trapTheSoul.html#trap-the-soul"
                          }
    },
    {
        "id":  "holy-word",
        "name":  {
                     "ru":  "Святое слово",
                     "en":  "Holy Word"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holyWord",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holyWord.html#holy-word"
                          }
    },
    {
        "id":  "imprisonment",
        "name":  {
                     "ru":  "Заключение",
                     "en":  "Imprisonment"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/imprisonment",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/imprisonment.html#imprisonment"
                          }
    },
    {
        "id":  "chill-touch",
        "name":  {
                     "ru":  "Ледяное прикосновение",
                     "en":  "Chill Touch"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/chillTouch",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/chillTouch.html#chill-touch"
                          }
    },
    {
        "id":  "mage-s-magnificent-mansion",
        "name":  {
                     "ru":  "Великолепный особняк волшебника",
                     "en":  "Mage\u0027s Magnificent Mansion"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mageMagnificentMansion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mageSMagnificentMansion.html#mage-s-magnificent-mansion"
                          }
    },
    {
        "id":  "owl-s-wisdom",
        "name":  {
                     "ru":  "Совиная мудрость",
                     "en":  "Owl\u0027s Wisdom"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Druid":  2,
                            "Paladin":  2,
                            "Ranger":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/owlWisdom",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/owlSWisdom.html#owl-s-wisdom"
                          }
    },
    {
        "id":  "find-the-path",
        "name":  {
                     "ru":  "Поиск пути",
                     "en":  "Find the Path"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6,
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/findThePath",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/findThePath.html#find-the-path"
                          }
    },
    {
        "id":  "shout-greater",
        "name":  {
                     "ru":  "Вопль",
                     "en":  "Shout, Greater"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shout",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shout.html#shout-greater"
                          }
    },
    {
        "id":  "soften-earth-and-stone",
        "name":  {
                     "ru":  "Размягчение земли и камня",
                     "en":  "Soften Earth and Stone"
                 },
        "classLevels":  {
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/softenEarthAndStone",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/softenEarthAndStone.html#soften-earth-and-stone"
                          }
    },
    {
        "id":  "undetectable-alignment",
        "name":  {
                     "ru":  "Скрытое мировоззрение",
                     "en":  "Undetectable Alignment"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  2,
                            "Paladin":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/undetectableAlignment",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/undetectableAlignment.html#undetectable-alignment"
                          }
    },
    {
        "id":  "touch-of-idiocy",
        "name":  {
                     "ru":  "Отупляющее касание",
                     "en":  "Touch of Idiocy"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/touchOfIdiocy",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/touchOfIdiocy.html#touch-of-idiocy"
                          }
    },
    {
        "id":  "flame-blade",
        "name":  {
                     "ru":  "Огненный клинок",
                     "en":  "Flame Blade"
                 },
        "classLevels":  {
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/flameBlade",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/flameBlade.html#flame-blade"
                          }
    },
    {
        "id":  "spell-resistance",
        "name":  {
                     "ru":  "Устойчивость к магии",
                     "en":  "Spell Resistance"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spellResistance",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spellResistance.html#spell-resistance"
                          }
    },
    {
        "id":  "liveoak",
        "name":  {
                     "ru":  "Сторожевой дуб",
                     "en":  "Liveoak"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/liveoak",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/liveoak.html#liveoak"
                          }
    },
    {
        "id":  "planar-ally-lesser",
        "name":  {
                     "ru":  "Потусторонний союзник",
                     "en":  "Planar Ally, Lesser"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planarAlly",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planarAlly.html#planar-ally-lesser"
                          }
    },
    {
        "id":  "antiplant-shell",
        "name":  {
                     "ru":  "Барьер для растений",
                     "en":  "Antiplant Shell"
                 },
        "classLevels":  {
                            "Druid":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/antiplantShell",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/antiplantShell.html#antiplant-shell"
                          }
    },
    {
        "id":  "dispel-chaos",
        "name":  {
                     "ru":  "Рассеивание хаоса",
                     "en":  "Dispel Chaos"
                 },
        "classLevels":  {
                            "Paladin":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dispelChaos",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dispelChaos.html#dispel-chaos"
                          }
    },
    {
        "id":  "symbol-of-death",
        "name":  {
                     "ru":  "Символ смерти",
                     "en":  "Symbol of Death"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfDeath",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfDeath.html#symbol-of-death"
                          }
    },
    {
        "id":  "symbol-of-persuasion",
        "name":  {
                     "ru":  "Символ обольщения",
                     "en":  "Symbol of Persuasion"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfPersuasion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfPersuasion.html#symbol-of-persuasion"
                          }
    },
    {
        "id":  "symbol-of-insanity",
        "name":  {
                     "ru":  "Символ безумия",
                     "en":  "Symbol of Insanity"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfInsanity",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfInsanity.html#symbol-of-insanity"
                          }
    },
    {
        "id":  "prayer",
        "name":  {
                     "ru":  "Молебен",
                     "en":  "Prayer"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Paladin":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/prayer",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/prayer.html#prayer"
                          }
    },
    {
        "id":  "spellstaff",
        "name":  {
                     "ru":  "Заклятие в посохе",
                     "en":  "Spellstaff"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spellstaff",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spellstaff.html#spellstaff"
                          }
    },
    {
        "id":  "death-ward",
        "name":  {
                     "ru":  "Защита от смерти",
                     "en":  "Death Ward"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Druid":  5,
                            "Paladin":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/deathWard",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/deathWard.html#death-ward"
                          }
    },
    {
        "id":  "crushing-despair",
        "name":  {
                     "ru":  "Сокрушительное отчаяние",
                     "en":  "Crushing Despair"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/crushingDespair",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/crushingDespair.html#crushing-despair"
                          }
    },
    {
        "id":  "geas-lesser",
        "name":  {
                     "ru":  "Гейс/миссия",
                     "en":  "Geas, Lesser"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/geasQuest",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/geasQuest.html#geas-lesser"
                          }
    },
    {
        "id":  "rope-trick",
        "name":  {
                     "ru":  "Фокус с веревкой",
                     "en":  "Rope Trick"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/ropeTrick",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/ropeTrick.html#rope-trick"
                          }
    },
    {
        "id":  "produce-flame",
        "name":  {
                     "ru":  "Сотворить пламя",
                     "en":  "Produce Flame"
                 },
        "classLevels":  {
                            "Druid":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/produceFlame",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/produceFlame.html#produce-flame"
                          }
    },
    {
        "id":  "stone-shape",
        "name":  {
                     "ru":  "Преображение камня",
                     "en":  "Stone Shape"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Druid":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stoneShape",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stoneShape.html#stone-shape"
                          }
    },
    {
        "id":  "destruction",
        "name":  {
                     "ru":  "Уничтожение",
                     "en":  "Destruction"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/destruction",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/destruction.html#destruction"
                          }
    },
    {
        "id":  "comprehend-languages",
        "name":  {
                     "ru":  "Понимание языков",
                     "en":  "Comprehend Languages"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/comprehendLanguages",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/comprehendLanguages.html#comprehend-languages"
                          }
    },
    {
        "id":  "summon-nature-s-ally-i",
        "name":  {
                     "ru":  "Призыв природного союзника I",
                     "en":  "Summon Nature\u0027s Ally I"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-i"
                          }
    },
    {
        "id":  "glitterdust",
        "name":  {
                     "ru":  "Блестки",
                     "en":  "Glitterdust"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/glitterdust",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/glitterdust.html#glitterdust"
                          }
    },
    {
        "id":  "dominate-animal",
        "name":  {
                     "ru":  "Подчинение животного",
                     "en":  "Dominate Animal"
                 },
        "classLevels":  {
                            "Druid":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dominateAnimal",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dominateAnimal.html#dominate-animal"
                          }
    },
    {
        "id":  "wood-shape",
        "name":  {
                     "ru":  "Преображение дерева",
                     "en":  "Wood Shape"
                 },
        "classLevels":  {
                            "Druid":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/woodShape",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/woodShape.html#wood-shape"
                          }
    },
    {
        "id":  "control-plants",
        "name":  {
                     "ru":  "Власть над растениями",
                     "en":  "Control Plants"
                 },
        "classLevels":  {
                            "Druid":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/controlPlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/controlPlants.html#control-plants"
                          }
    },
    {
        "id":  "elemental-body-i",
        "name":  {
                     "ru":  "Стихийная форма I",
                     "en":  "Elemental Body I"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/elementalBodyI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/elementalBody.html#elemental-body-i"
                          }
    },
    {
        "id":  "endure-elements",
        "name":  {
                     "ru":  "Защита от непогоды",
                     "en":  "Endure Elements"
                 },
        "classLevels":  {
                            "Cleric":  1,
                            "Druid":  1,
                            "Paladin":  1,
                            "Ranger":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/endureElements",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/endureElements.html#endure-elements"
                          }
    },
    {
        "id":  "rainbow-pattern",
        "name":  {
                     "ru":  "Радужный узор",
                     "en":  "Rainbow Pattern"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/rainbowPattern",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/rainbowPattern.html#rainbow-pattern"
                          }
    },
    {
        "id":  "sepia-snake-sigil",
        "name":  {
                     "ru":  "Змеиный знак",
                     "en":  "Sepia Snake Sigil"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/sepiaSnakeSigil",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/sepiaSnakeSigil.html#sepia-snake-sigil"
                          }
    },
    {
        "id":  "elemental-body-iv",
        "name":  {
                     "ru":  "Стихийная форма IV",
                     "en":  "Elemental Body IV"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/elementalBodyIV",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/elementalBody.html#elemental-body-iv"
                          }
    },
    {
        "id":  "shield-of-faith",
        "name":  {
                     "ru":  "Щит веры",
                     "en":  "Shield of Faith"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shieldOfFaith",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shieldOfFaith.html#shield-of-faith"
                          }
    },
    {
        "id":  "read-magic",
        "name":  {
                     "ru":  "Чтение магических текстов",
                     "en":  "Read Magic"
                 },
        "classLevels":  {
                            "Paladin":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/readMagic",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/readMagic.html#read-magic"
                          }
    },
    {
        "id":  "shapechange",
        "name":  {
                     "ru":  "Метаморфоза",
                     "en":  "Shapechange"
                 },
        "classLevels":  {
                            "Druid":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shapechange",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shapechange.html#shapechange"
                          }
    },
    {
        "id":  "control-water",
        "name":  {
                     "ru":  "Власть над водой",
                     "en":  "Control Water"
                 },
        "classLevels":  {
                            "Cleric":  4,
                            "Druid":  4,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/controlWater",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/controlWater.html#control-water"
                          }
    },
    {
        "id":  "telepathic-bond",
        "name":  {
                     "ru":  "Телепатическая связь",
                     "en":  "Telepathic Bond"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/telepathicBond",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/telepathicBond.html#telepathic-bond"
                          }
    },
    {
        "id":  "chaos-hammer",
        "name":  {
                     "ru":  "Молот хаоса",
                     "en":  "Chaos Hammer"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/chaosHammer",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/chaosHammer.html#chaos-hammer"
                          }
    },
    {
        "id":  "barkskin",
        "name":  {
                     "ru":  "Дубовая кожа",
                     "en":  "Barkskin"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/barkskin",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/barkskin.html#barkskin"
                          }
    },
    {
        "id":  "summon-monster-viii",
        "name":  {
                     "ru":  "Призыв чудовища VIII",
                     "en":  "Summon Monster VIII"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterVIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-viii"
                          }
    },
    {
        "id":  "mirage-arcana",
        "name":  {
                     "ru":  "Мистический мираж",
                     "en":  "Mirage Arcana"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/mirageArcana",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/mirageArcana.html#mirage-arcana"
                          }
    },
    {
        "id":  "analyze-dweomer",
        "name":  {
                     "ru":  "Анализ чар",
                     "en":  "Analyze Dweomer"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/analyzeDweomer",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/analyzeDweomer.html#analyze-dweomer"
                          }
    },
    {
        "id":  "cure-moderate-wounds",
        "name":  {
                     "ru":  "Исцеление серьезных ранений",
                     "en":  "Cure Moderate Wounds"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Cleric":  2,
                            "Druid":  3,
                            "Paladin":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cureModerateWounds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cureModerateWounds.html#cure-moderate-wounds"
                          }
    },
    {
        "id":  "phantom-steed",
        "name":  {
                     "ru":  "Фантомный скакун",
                     "en":  "Phantom Steed"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/phantomSteed",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/phantomSteed.html#phantom-steed"
                          }
    },
    {
        "id":  "mark-of-justice",
        "name":  {
                     "ru":  "Метка справедливости",
                     "en":  "Mark of Justice"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Paladin":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/markOfJustice",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/markOfJustice.html#mark-of-justice"
                          }
    },
    {
        "id":  "elemental-swarm",
        "name":  {
                     "ru":  "Туча элементалей",
                     "en":  "Elemental Swarm"
                 },
        "classLevels":  {
                            "Druid":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/elementalSwarm",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/elementalSwarm.html#elemental-swarm"
                          }
    },
    {
        "id":  "false-vision",
        "name":  {
                     "ru":  "Ложная картина",
                     "en":  "False Vision"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/falseVision",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/falseVision.html#false-vision"
                          }
    },
    {
        "id":  "dispel-magic",
        "name":  {
                     "ru":  "Рассеивание магии",
                     "en":  "Dispel Magic"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Cleric":  3,
                            "Druid":  4,
                            "Paladin":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dispelMagic",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/dispelMagic.html#dispel-magic"
                          }
    },
    {
        "id":  "glyph-of-warding",
        "name":  {
                     "ru":  "Сторожевая печать",
                     "en":  "Glyph of Warding"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/glyphOfWarding",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/glyphOfWarding.html#glyph-of-warding"
                          }
    },
    {
        "id":  "reduce-person",
        "name":  {
                     "ru":  "Уменьшение гуманоида",
                     "en":  "Reduce Person"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/reducePerson",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/reducePerson.html#reduce-person"
                          }
    },
    {
        "id":  "curse-water",
        "name":  {
                     "ru":  "Осквернение воды",
                     "en":  "Curse Water"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/curseWater",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/curseWater.html#curse-water"
                          }
    },
    {
        "id":  "animal-growth",
        "name":  {
                     "ru":  "Увеличение животных",
                     "en":  "Animal Growth"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Ranger":  4,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/animalGrowth",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/animalGrowth.html#animal-growth"
                          }
    },
    {
        "id":  "changestaff",
        "name":  {
                     "ru":  "Оживший посох",
                     "en":  "Changestaff"
                 },
        "classLevels":  {
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/changestaff",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/changestaff.html#changestaff"
                          }
    },
    {
        "id":  "entangle",
        "name":  {
                     "ru":  "Опутывание",
                     "en":  "Entangle"
                 },
        "classLevels":  {
                            "Druid":  1,
                            "Ranger":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/entangle",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/entangle.html#entangle"
                          }
    },
    {
        "id":  "fox-s-cunning",
        "name":  {
                     "ru":  "Лисья хитрость",
                     "en":  "Fox\u0027s Cunning"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/foxCunning",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/foxSCunning.html#fox-s-cunning"
                          }
    },
    {
        "id":  "shambler",
        "name":  {
                     "ru":  "Создание ходоков",
                     "en":  "Shambler"
                 },
        "classLevels":  {
                            "Druid":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shambler",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shambler.html#shambler"
                          }
    },
    {
        "id":  "hypnotic-pattern",
        "name":  {
                     "ru":  "Завораживающий узор",
                     "en":  "Hypnotic Pattern"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hypnoticPattern",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hypnoticPattern.html#hypnotic-pattern"
                          }
    },
    {
        "id":  "symbol-of-fear",
        "name":  {
                     "ru":  "Символ ужаса",
                     "en":  "Symbol of Fear"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfFear",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfFear.html#symbol-of-fear"
                          }
    },
    {
        "id":  "secret-page",
        "name":  {
                     "ru":  "Тайная страница",
                     "en":  "Secret Page"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/secretPage",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/secretPage.html#secret-page"
                          }
    },
    {
        "id":  "summon-monster-iv",
        "name":  {
                     "ru":  "Призыв чудовища IV",
                     "en":  "Summon Monster IV"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Cleric":  4,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterIV",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-iv"
                          }
    },
    {
        "id":  "spider-climb",
        "name":  {
                     "ru":  "Паучьи лапы",
                     "en":  "Spider Climb"
                 },
        "classLevels":  {
                            "Druid":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/spiderClimb",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/spiderClimb.html#spider-climb"
                          }
    },
    {
        "id":  "arcane-lock",
        "name":  {
                     "ru":  "Мистический замок",
                     "en":  "Arcane Lock"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/arcaneLock",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/arcaneLock.html#arcane-lock"
                          }
    },
    {
        "id":  "command",
        "name":  {
                     "ru":  "Приказ",
                     "en":  "Command"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/command",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/command.html#command"
                          }
    },
    {
        "id":  "discern-location",
        "name":  {
                     "ru":  "Точный адрес",
                     "en":  "Discern Location"
                 },
        "classLevels":  {
                            "Cleric":  8,
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/discernLocation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/discernLocation.html#discern-location"
                          }
    },
    {
        "id":  "soul-bind",
        "name":  {
                     "ru":  "Вместилище для души",
                     "en":  "Soul Bind"
                 },
        "classLevels":  {
                            "Cleric":  9,
                            "Sorcerer/Wizard":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/soulBind",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/soulBind.html#soul-bind"
                          }
    },
    {
        "id":  "suggestion-mass",
        "name":  {
                     "ru":  "Внушение",
                     "en":  "Suggestion, Mass"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/suggestion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/suggestion.html#suggestion-mass"
                          }
    },
    {
        "id":  "resurrection",
        "name":  {
                     "ru":  "Воскрешение",
                     "en":  "Resurrection"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/resurrection",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/resurrection.html#resurrection"
                          }
    },
    {
        "id":  "tree-stride",
        "name":  {
                     "ru":  "Древесный путь",
                     "en":  "Tree Stride"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Ranger":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/treeStride",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/treeStride.html#tree-stride"
                          }
    },
    {
        "id":  "make-whole",
        "name":  {
                     "ru":  "Ремонт",
                     "en":  "Make Whole"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/makeWhole",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/makeWhole.html#make-whole"
                          }
    },
    {
        "id":  "holy-sword",
        "name":  {
                     "ru":  "Священный меч",
                     "en":  "Holy Sword"
                 },
        "classLevels":  {
                            "Paladin":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holySword",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holySword.html#holy-sword"
                          }
    },
    {
        "id":  "summon-monster-vii",
        "name":  {
                     "ru":  "Призыв чудовища VII",
                     "en":  "Summon Monster VII"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterVII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-vii"
                          }
    },
    {
        "id":  "shadow-evocation-greater",
        "name":  {
                     "ru":  "Теневое разрушение",
                     "en":  "Shadow Evocation, Greater"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shadowEvocation",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shadowEvocation.html#shadow-evocation-greater"
                          }
    },
    {
        "id":  "iron-body",
        "name":  {
                     "ru":  "Стальное тело",
                     "en":  "Iron Body"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/ironBody",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/ironBody.html#iron-body"
                          }
    },
    {
        "id":  "geas-quest",
        "name":  {
                     "ru":  "Гейс/миссия",
                     "en":  "Geas/Quest"
                 },
        "classLevels":  {
                            "Bard":  6,
                            "Cleric":  6,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/geasQuest",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/geasQuest.html#geas-quest"
                          }
    },
    {
        "id":  "slay-living",
        "name":  {
                     "ru":  "Сразить живого",
                     "en":  "Slay Living"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/slayLiving",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/slayLiving.html#slay-living"
                          }
    },
    {
        "id":  "obscure-object",
        "name":  {
                     "ru":  "Сокрытие предмета",
                     "en":  "Obscure Object"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  3,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/obscureObject",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/obscureObject.html#obscure-object"
                          }
    },
    {
        "id":  "acid-arrow",
        "name":  {
                     "ru":  "Кислотная стрела",
                     "en":  "Acid Arrow"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/acidArrow",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/acidArrow.html#acid-arrow"
                          }
    },
    {
        "id":  "desecrate",
        "name":  {
                     "ru":  "Осквернение",
                     "en":  "Desecrate"
                 },
        "classLevels":  {
                            "Cleric":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/desecrate",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/desecrate.html#desecrate"
                          }
    },
    {
        "id":  "restoration-greater",
        "name":  {
                     "ru":  "Восстановление",
                     "en":  "Restoration, Greater"
                 },
        "classLevels":  {
                            "Cleric":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/restoration",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/restoration.html#restoration-greater"
                          }
    },
    {
        "id":  "speak-with-plants",
        "name":  {
                     "ru":  "Разговор с растениями",
                     "en":  "Speak with Plants"
                 },
        "classLevels":  {
                            "Bard":  4,
                            "Druid":  3,
                            "Ranger":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/speakWithPlants",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/speakWithPlants.html#speak-with-plants"
                          }
    },
    {
        "id":  "contact-other-plane",
        "name":  {
                     "ru":  "Связь с иным планом",
                     "en":  "Contact Other Plane"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/contactOtherPlane",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/contactOtherPlane.html#contact-other-plane"
                          }
    },
    {
        "id":  "web",
        "name":  {
                     "ru":  "Паутина",
                     "en":  "Web"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/web",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/web.html#web"
                          }
    },
    {
        "id":  "control-undead",
        "name":  {
                     "ru":  "Власть над нежитью",
                     "en":  "Control Undead"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/controlUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/controlUndead.html#control-undead"
                          }
    },
    {
        "id":  "beast-shape-i",
        "name":  {
                     "ru":  "Облик зверя I",
                     "en":  "Beast Shape I"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/beastShapeI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/beastShape.html#beast-shape-i"
                          }
    },
    {
        "id":  "reverse-gravity",
        "name":  {
                     "ru":  "Обратная гравитация",
                     "en":  "Reverse Gravity"
                 },
        "classLevels":  {
                            "Druid":  8,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/reverseGravity",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/reverseGravity.html#reverse-gravity"
                          }
    },
    {
        "id":  "holy-smite",
        "name":  {
                     "ru":  "Священный гнев",
                     "en":  "Holy Smite"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/holySmite",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/holySmite.html#holy-smite"
                          }
    },
    {
        "id":  "nightmare",
        "name":  {
                     "ru":  "Кошмар",
                     "en":  "Nightmare"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/nightmare",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/nightmare.html#nightmare"
                          }
    },
    {
        "id":  "planar-ally-greater",
        "name":  {
                     "ru":  "Потусторонний союзник",
                     "en":  "Planar Ally, Greater"
                 },
        "classLevels":  {
                            "Cleric":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planarAlly",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planarAlly.html#planar-ally-greater"
                          }
    },
    {
        "id":  "magic-missile",
        "name":  {
                     "ru":  "Волшебная стрела",
                     "en":  "Magic Missile"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicMissile",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicMissile.html#magic-missile"
                          }
    },
    {
        "id":  "darkvision",
        "name":  {
                     "ru":  "Ночное зрение",
                     "en":  "Darkvision"
                 },
        "classLevels":  {
                            "Ranger":  3,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/darkvision",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/darkvision.html#darkvision"
                          }
    },
    {
        "id":  "order-s-wrath",
        "name":  {
                     "ru":  "Десница закона",
                     "en":  "Order\u0027s Wrath"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/orderWrath",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/orderSWrath.html#order-s-wrath"
                          }
    },
    {
        "id":  "ventriloquism",
        "name":  {
                     "ru":  "Чревовещание",
                     "en":  "Ventriloquism"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/ventriloquism",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/ventriloquism.html#ventriloquism"
                          }
    },
    {
        "id":  "fire-seeds",
        "name":  {
                     "ru":  "Огненные семена",
                     "en":  "Fire Seeds"
                 },
        "classLevels":  {
                            "Druid":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/fireSeeds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/fireSeeds.html#fire-seeds"
                          }
    },
    {
        "id":  "heroism-greater",
        "name":  {
                     "ru":  "Героизм",
                     "en":  "Heroism, Greater"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/heroism",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/heroism.html#heroism-greater"
                          }
    },
    {
        "id":  "heal-mount",
        "name":  {
                     "ru":  "Излечение скакуна",
                     "en":  "Heal Mount"
                 },
        "classLevels":  {
                            "Paladin":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/healMount",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/healMount.html#heal-mount"
                          }
    },
    {
        "id":  "solid-fog",
        "name":  {
                     "ru":  "Плотный туман",
                     "en":  "Solid Fog"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/solidFog",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/solidFog.html#solid-fog"
                          }
    },
    {
        "id":  "invisibility-sphere",
        "name":  {
                     "ru":  "Сфера невидимости",
                     "en":  "Invisibility Sphere"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/invisibilitySphere",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/invisibilitySphere.html#invisibility-sphere"
                          }
    },
    {
        "id":  "clenched-fist",
        "name":  {
                     "ru":  "Сжатый кулак",
                     "en":  "Clenched Fist"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/clenchedFist",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/clenchedFist.html#clenched-fist"
                          }
    },
    {
        "id":  "teleport",
        "name":  {
                     "ru":  "Телепортация",
                     "en":  "Teleport"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/teleport",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/teleport.html#teleport"
                          }
    },
    {
        "id":  "nondetection",
        "name":  {
                     "ru":  "Необнаружимость",
                     "en":  "Nondetection"
                 },
        "classLevels":  {
                            "Ranger":  4,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/nondetection",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/nondetection.html#nondetection"
                          }
    },
    {
        "id":  "shield",
        "name":  {
                     "ru":  "Щит",
                     "en":  "Shield"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shield",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shield.html#shield"
                          }
    },
    {
        "id":  "magic-vestment",
        "name":  {
                     "ru":  "Волшебное одеяние",
                     "en":  "Magic Vestment"
                 },
        "classLevels":  {
                            "Cleric":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/magicVestment",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/magicVestment.html#magic-vestment"
                          }
    },
    {
        "id":  "repulsion",
        "name":  {
                     "ru":  "Отторжение",
                     "en":  "Repulsion"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/repulsion",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/repulsion.html#repulsion"
                          }
    },
    {
        "id":  "unholy-blight",
        "name":  {
                     "ru":  "Нечестивая погибель",
                     "en":  "Unholy Blight"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/unholyBlight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/unholyBlight.html#unholy-blight"
                          }
    },
    {
        "id":  "plane-shift",
        "name":  {
                     "ru":  "Планарный переход",
                     "en":  "Plane Shift"
                 },
        "classLevels":  {
                            "Cleric":  5,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planeShift",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planeShift.html#plane-shift"
                          }
    },
    {
        "id":  "elemental-body-iii",
        "name":  {
                     "ru":  "Стихийная форма III",
                     "en":  "Elemental Body III"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/elementalBodyIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/elementalBody.html#elemental-body-iii"
                          }
    },
    {
        "id":  "ray-of-exhaustion",
        "name":  {
                     "ru":  "Обессиливающий луч",
                     "en":  "Ray of Exhaustion"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/exhaustionRay",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/rayOfExhaustion.html#ray-of-exhaustion"
                          }
    },
    {
        "id":  "hide-from-undead",
        "name":  {
                     "ru":  "Невидимость для нежити",
                     "en":  "Hide from Undead"
                 },
        "classLevels":  {
                            "Cleric":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/hideFromUndead",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/hideFromUndead.html#hide-from-undead"
                          }
    },
    {
        "id":  "planar-binding-lesser",
        "name":  {
                     "ru":  "Потусторонний слуга",
                     "en":  "Planar Binding, Lesser"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/planarBinding",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/planarBinding.html#planar-binding-lesser"
                          }
    },
    {
        "id":  "gentle-repose",
        "name":  {
                     "ru":  "Посмертный покой",
                     "en":  "Gentle Repose"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/gentleRepose",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/gentleRepose.html#gentle-repose"
                          }
    },
    {
        "id":  "banishment",
        "name":  {
                     "ru":  "Изгнание",
                     "en":  "Banishment"
                 },
        "classLevels":  {
                            "Cleric":  6,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/banishment",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/banishment.html#banishment"
                          }
    },
    {
        "id":  "control-winds",
        "name":  {
                     "ru":  "Управление ветрами",
                     "en":  "Control Winds"
                 },
        "classLevels":  {
                            "Druid":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/controlWinds",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/controlWinds.html#control-winds"
                          }
    },
    {
        "id":  "stoneskin",
        "name":  {
                     "ru":  "Каменная кожа",
                     "en":  "Stoneskin"
                 },
        "classLevels":  {
                            "Druid":  5,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/stoneskin",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/stoneskin.html#stoneskin"
                          }
    },
    {
        "id":  "symbol-of-weakness",
        "name":  {
                     "ru":  "Символ слабости",
                     "en":  "Symbol of Weakness"
                 },
        "classLevels":  {
                            "Cleric":  7,
                            "Sorcerer/Wizard":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/symbolOfWeakness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/symbolOfWeakness.html#symbol-of-weakness"
                          }
    },
    {
        "id":  "summon-nature-s-ally-iii",
        "name":  {
                     "ru":  "Призыв природного союзника III",
                     "en":  "Summon Nature\u0027s Ally III"
                 },
        "classLevels":  {
                            "Druid":  3,
                            "Ranger":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonNatureAllyIII",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonNatureSAlly.html#summon-nature-s-ally-iii"
                          }
    },
    {
        "id":  "true-resurrection",
        "name":  {
                     "ru":  "Истинное воскрешение",
                     "en":  "True Resurrection"
                 },
        "classLevels":  {
                            "Cleric":  9
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/trueResurrection",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/trueResurrection.html#true-resurrection"
                          }
    },
    {
        "id":  "wall-of-iron",
        "name":  {
                     "ru":  "Железная стена",
                     "en":  "Wall of Iron"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wallOfIron",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wallOfIron.html#wall-of-iron"
                          }
    },
    {
        "id":  "telekinetic-sphere",
        "name":  {
                     "ru":  "Кинетическая сфера",
                     "en":  "Telekinetic Sphere"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  8
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/telekineticSphere",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/telekineticSphere.html#telekinetic-sphere"
                          }
    },
    {
        "id":  "form-of-the-dragon-i",
        "name":  {
                     "ru":  "Облик дракона I",
                     "en":  "Form of the Dragon I"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  6
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/dragonFormI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/formOfTheDragon.html#form-of-the-dragon-i"
                          }
    },
    {
        "id":  "shield-other",
        "name":  {
                     "ru":  "Щит для другого",
                     "en":  "Shield Other"
                 },
        "classLevels":  {
                            "Cleric":  2,
                            "Paladin":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/shieldOther",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/shieldOther.html#shield-other"
                          }
    },
    {
        "id":  "wall-of-ice",
        "name":  {
                     "ru":  "Стена льда",
                     "en":  "Wall of Ice"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/wallOfIce",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/wallOfIce.html#wall-of-ice"
                          }
    },
    {
        "id":  "vampiric-touch",
        "name":  {
                     "ru":  "Касание вампира",
                     "en":  "Vampiric Touch"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/vampiricTouch",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/vampiricTouch.html#vampiric-touch"
                          }
    },
    {
        "id":  "modify-memory",
        "name":  {
                     "ru":  "Манипуляция памятью",
                     "en":  "Modify Memory"
                 },
        "classLevels":  {
                            "Bard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/modifyMemory",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/modifyMemory.html#modify-memory"
                          }
    },
    {
        "id":  "righteous-might",
        "name":  {
                     "ru":  "Праведная мощь",
                     "en":  "Righteous Might"
                 },
        "classLevels":  {
                            "Cleric":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/righteousMight",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/righteousMight.html#righteous-might"
                          }
    },
    {
        "id":  "cloudkill",
        "name":  {
                     "ru":  "Смертельное облако",
                     "en":  "Cloudkill"
                 },
        "classLevels":  {
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/cloudkill",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/cloudkill.html#cloudkill"
                          }
    },
    {
        "id":  "unseen-servant",
        "name":  {
                     "ru":  "Невидимый слуга",
                     "en":  "Unseen Servant"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/unseenServant",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/unseenServant.html#unseen-servant"
                          }
    },
    {
        "id":  "remove-curse",
        "name":  {
                     "ru":  "Снятие проклятия",
                     "en":  "Remove Curse"
                 },
        "classLevels":  {
                            "Bard":  3,
                            "Cleric":  3,
                            "Paladin":  3,
                            "Sorcerer/Wizard":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/removeCurse",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/removeCurse.html#remove-curse"
                          }
    },
    {
        "id":  "whispering-wind",
        "name":  {
                     "ru":  "Шепот ветра",
                     "en":  "Whispering Wind"
                 },
        "classLevels":  {
                            "Bard":  2,
                            "Sorcerer/Wizard":  2
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/whisperingWind",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/whisperingWind.html#whispering-wind"
                          }
    },
    {
        "id":  "transmute-metal-to-wood",
        "name":  {
                     "ru":  "Превращение металла в дерево",
                     "en":  "Transmute Metal to Wood"
                 },
        "classLevels":  {
                            "Druid":  7
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/transmuteMetalToWood",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/transmuteMetalToWood.html#transmute-metal-to-wood"
                          }
    },
    {
        "id":  "summon-monster-i",
        "name":  {
                     "ru":  "Призыв чудовища I",
                     "en":  "Summon Monster I"
                 },
        "classLevels":  {
                            "Bard":  1,
                            "Cleric":  1,
                            "Sorcerer/Wizard":  1
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/summonMonsterI",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/summonMonster.html#summon-monster-i"
                          }
    },
    {
        "id":  "seeming",
        "name":  {
                     "ru":  "Личины",
                     "en":  "Seeming"
                 },
        "classLevels":  {
                            "Bard":  5,
                            "Sorcerer/Wizard":  5
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/seeming",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/seeming.html#seeming"
                          }
    },
    {
        "id":  "remove-blindness-deafness",
        "name":  {
                     "ru":  "Снятие слепоты/глухоты",
                     "en":  "Remove Blindness/Deafness"
                 },
        "classLevels":  {
                            "Cleric":  3,
                            "Paladin":  3
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/removeBlindnessDeafness",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/removeBlindnessDeafness.html#remove-blindness-deafness"
                          }
    },
    {
        "id":  "divination",
        "name":  {
                     "ru":  "Прорицание",
                     "en":  "Divination"
                 },
        "classLevels":  {
                            "Cleric":  4
                        },
        "source":  "Pathfinder RPG Core Rulebook",
        "referenceUrls":  {
                              "ru":  "https://pathfinder.family/spell/divination",
                              "en":  "https://pathfinder.d20srd.org/coreRulebook/spells/divination.html#divination"
                          }
    }
];
